<template>
  <div id='prodSettBG'>
    <div id="prodSetP" class="ui container">
      <p>&nbsp;</p>

      <h1 class="ui inverted grey header" style="position:relative;text-shadow:#333 1px 2px 3px;">
        <i class="cogs icon"></i>
        <div class="content" style="">
          <span style="color:peru;">Sentry</span><span style="color:steelblue;">Kit</span>
           Settings
        </div>
        <button class="small ui compact button" style="position:absolute;right:0px;top:12px;" v-on:click="$router.push($root.defaultPath)"><i class="left chevron icon"></i>Back</button>
      </h1>

      <div class="ui padded segment">
        <div v-if="message" class="ui success message">
          <i class="close icon" v-on:click="message=''"></i>
          <div class="header">
            {{message}}
          </div>
        </div>
        <div v-else-if="error" class="ui error message">
          <i class="close icon" v-on:click="error=''"></i>
          <div class="header">Error</div>
          <p>{{error}}</p>
        </div>

        <form class="ui form">
          <div class="ui two column stackable padded grid">
            <!-- Mange Storefront (Seller ID)-->
            <div class="row marginBotton-1">
              <div class="sixteen wide column">
                <h3 class="ui horizontal divider header">
                  <i class="sliders horizontal icon"></i>
                  Manage Storefront (Seller ID)
                </h3>
              </div>
            </div>
            <div class="ui column centered grid" style="width: 100%;">
              <div class="column row sub-heading">Set up and manage storefront(s) to mirror your team structure (e.g. agencies may set up by brand client, merchants may set up multiple storefronts, and brands may set up by product family).</div>
            </div>
            <div class="ui two column centered grid" style="margin-top: -1rem;">
              <div class="four wide">
                <button type="button" class="ui labeled icon button borderButton" v-if="isOwner" v-on:click="showAddSellerAccountModal"><i class="add circle icon"></i>Add Storefront (Seller ID)</button>
              </div>
            </div>
            <div class="row">
              <div class="two wide column">
                <h4 v-bind:class="sellersDirty ? 'changed-color' : ''">Seller Accounts</h4>
              </div>
              <div v-if="!isEmptyObject(sellers)" class="twelve wide column">
                <table class="ui very basic compact table">
                  <thead>
                    <tr>
                      <th class="three wide">Seller ID</th>
                      <th class="one wide">Region</th>
                      <th class="four wide">Account nick name</th>
                      <th class="three wide">Auth Token</th>
                      <th v-if="showAdvertisementApiSettings" class="two wide" data-tooltip="Advertisement spending data is used by the Profit Dashboard">Connect to Ad API</th>
                      <th v-if="anyAccountMayNeedReAuthorization" class="one wide"></th>
                      <th class="one wide">Re-Authorize</th>
                      <th class="one wide" v-if="isOwner">Delete</th>
                    </tr>
                  </thead>
                  <tbody>
                    <seller-account v-for="s in filteredSellers" :key="s.sellerId.value" :seller="s" :showAdvertisementApiSettings="showAdvertisementApiSettings" :anyAccountMayNeedReAuthorization="anyAccountMayNeedReAuthorization" :isOwner="isOwner"
                      v-on:account-changed="onSellerAccountChanged" v-on:sellerAccountDeleted="sellerAccountDeleted"
                      ref="sellerAccounts" />
                  </tbody>
                </table>
              </div>
              <div v-else class="twelve wide column">
                <i>No seller accounts found</i>
              </div>
            </div>
            <div class="ui container">
              <div class="ui clearing">
                  <button v-bind:class="dirty ? 'ui right floated primary button' : 'ui right floated primary disabled button'" v-on:click="save">Save</button>

              </div>
            </div>
            <!--./ Manage Storefront-->

            <!-- Manage Users-->
            <div class="row marginBotton-1 margin-top-2" v-show="isOwner">
              <div class="sixteen wide column">
                <h3 class="ui horizontal divider header">
                  <i class="sliders horizontal icon"></i>
                  Manage Your Users
                </h3>
              </div>
            </div>

            <div class="row centered" v-if="successMessage">
              <div class="ui positive message transition" style="width: 100%;">
              <!-- <i class="close icon"></i> -->
              <div class="header">
                {{ successMessage }}
              </div>
            </div>
            </div>
            <div class="ui column centered grid" style="width: 100%;" v-show="isOwner">
              <div class="column row sub-heading">View, manage, or add/deactivate users</div>
              <div class="four column centered row">
                <div class="column"><button type="button" class="ui labeled icon button borderButton" v-on:click="showAddUserModal" style="width: 180px !important;"><i class="add circle icon"></i>Add User</button></div>
                <div class="column" v-if="!showAllUsers"><button type="button" class="ui labeled icon button borderButton" v-on:click="toggleViewUser" style="padding-left: 3.071em !important;width: 180px !important;"><i class="eye icon"></i>View All Users</button></div>
                <div class="column" v-else><button type="button" class="ui labeled icon button borderButton" v-on:click="toggleViewUser" style="padding-left: 3.071em !important;width: 180px !important;"><i class="eye slash outline icon"></i>Hide All Users</button></div>
                <div class="column"><button type="button" class="ui labeled icon button borderButton" v-on:click="showDeactivateUserModal" style="padding-left: 3.071em !important;width: 180px !important;"><i class="trash alternate outline icon"></i>Deactivate Users</button></div>
              </div>
            </div>

            <div class="row" v-if="showAllUsers">
              <div class="two wide column">
              </div>
              <div class="fourteen wide column">
                <table class="ui very basic table emailSettingsTable">
                  <thead>
                    <tr>
                      <th class="six wide">Email</th>
                      <th>First Name</th>
                      <th>Last Name</th>
                      <th></th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-if="tenantUsersLoading && tenantUsers.length === 0">
                      <td colspan="4" class="disabled" style="text-align:center;padding:1.5em;">
                        Loading users…
                      </td>
                    </tr>
                    <template v-else>
                      <tr v-for="row in manageUsersTableRows" :key="'manage-user-' + row.user.id">
                        <td class="six wide">
                          {{ row.user.email }}
                          <span v-if="row.user.isOwner" class="ui tiny green basic label" style="margin-left:0.5em;">Owner</span>
                        </td>
                        <td>{{ row.user.firstName }}</td>
                        <td>{{ row.user.lastName }}</td>
                        <td class="five wide">
                          <template v-if="row.emailAddress">
                            <div style="min-width:90px;text-align:center;margin-right:10px;background-color:#fff !important;" v-bind:class="row.emailAddress.emailVerified && row.emailAddress.email === row.emailAddress.originalEmail ? 'ui green basic label' : 'ui red basic label'">{{ row.emailAddress.emailVerified ? 'Verified' : 'Not verified'}}</div>
                            <button data-tooltip="Resend Verification E-Mail" type="button" v-bind:class="!row.emailAddress.emailVerified && !row.emailAddress.isNew && !row.emailAddress.verificationEmailSent && row.emailAddress.email === row.emailAddress.originalEmail ? 'ui tiny icon button' : 'ui tiny icon disabled button'" v-on:click="resendVerification(row.emailAddress)">
                              <i class="mail icon"></i>
                            </button>
                          </template>
                          <span v-else class="disabled">—</span>
                        </td>
                      </tr>
                      <tr v-if="!tenantUsersLoading && manageUsersTableRows.length === 0">
                        <td colspan="4" class="disabled" style="text-align:center;padding:1.5em;">
                          No users on this account yet. Use Add User to invite teammates.
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
            </div>
            <!--./ Manage Users-->

            <!-- Manage Storefront teams -->
            <div class="row marginBotton-1 margin-top-2" v-show="isOwner">
              <div class="sixteen wide column">
                <h3 class="ui horizontal divider header">
                  <i class="sliders horizontal icon"></i>
                  Manage Storefront Teams
                </h3>
              </div>
            </div>

            <div class="row centered" v-if="teamsMessage">
              <div class="ui positive message transition" style="width: 100%;">
              <!-- <i class="close icon"></i> -->
              <div class="header">
                {{ teamsMessage }}
              </div>
            </div>
            </div>
            <div class="ui column centered grid" style="width: 100%;" v-show="isOwner">
              <div class="column row sub-heading">Select one or more storefronts, then choose users to grant access to <strong>all</strong> of those storefronts at once (or use Seller account Permission under each email to fine-tune).<br>The table lists teammates who already have access to at least one of the selected storefronts.</div>
            </div>

            <div class="row" v-show="isOwner">
              <div class="two wide column">
                <!-- <h4 style="padding-top:30px;" v-bind:class="emailDirty ? 'changed-color' : ''">Storefrant</h4> -->
              </div>

                <div class="four wide column">
                <div class="ui field">
                  <label>Storefronts</label>
                  <div class="ui fluid multiple search selection dropdown" ref="storefrontTeamSelect">
                    <input type="hidden" name="selectedTeamStorefronts">
                    <i class="dropdown icon"></i>
                    <div class="default text">Select storefronts</div>
                    <div class="menu">
                      <div
                        v-for="seller in sellers"
                        :key="'team-sf-' + (seller.sellerId && seller.sellerId.value != null ? seller.sellerId.value : seller.sellerId)"
                        class="item"
                        :data-value="String(seller.sellerId && seller.sellerId.value != null ? seller.sellerId.value : seller.sellerId)"
                      >
                        {{ seller.nickName }}
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="eight wide column">
                <div class="ui field">
                  <label>Select User</label>
                  <template>
                    <div class="ui multiple selection dropdown" ref="assignedUser">
                        <input type="hidden" name="selectedAssignedUser">
                        <i class="dropdown icon"></i>
                        <div class="default text">Select Users</div>
                        <div class="menu">
                          <div class="item" data-value="-1" @click="selectAssignedUser">All</div>
                          <div
                            v-for="u in tenantUsersForTeamAndAlertsDropdown"
                            :key="'team-user-' + u.id"
                            class="item"
                            :data-value="u.email"
                            @click="selectAssignedUser({ email: u.email, emailAddressId: u.id })"
                          >
                            {{ formatTenantUserDropdownLabel(u) }}
                          </div>
                        </div>
                      </div>
                  </template>
                  <!-- <select class="ui fluid search dropdown" name="helpModalMarketplace" v-model="storefrontUsers">
                    <option v-for="(ea, i) in emailAddresses" v-if="!ea.isDeleted && (!ea.isPrimary) && ea.isUser" value="ea.email}">{{ea.email}}</option>
                  </select> -->
                </div>
              </div>
            </div><!--.row-->
            <div class="row" v-if="isOwner">
                <div class="two wide column"></div>
                <div class="twelve wide column">
                  <table class="ui very basic compact table">
                      <tbody v-for="(ea, i) in assignedUserList" v-if="!ea.isDeleted && !ea.isPrimary" :key="ea.emailAddressId">
                        <tr>
                          <td class="six wide">{{ ea.email }}</td>
                          <td class="four wide">{{ ea.firstName }}</td>
                          <td class="four wide">{{ ea.lastName }}</td>
                          <td>
                            <div class="ui tiny icon button" v-on:click="deleteAssignedUser(ea)" data-tooltip="Delete Storefront User">
                            <i class="trash alternate outline icon"></i>
                            </div>
                          </td>
                        </tr>
                      </tbody>
                  </table>
                </div>
            </div>

            <div class="ui container" v-if="isOwner">
              <div class="ui clearing">
                  <button v-bind:class="(isEmptyObject(assignedUserList) || !selectedTeamStorefronts.length) ? 'ui right floated primary disabled button' : 'ui right floated primary button'" v-on:click.prevent="saveStorefrontTeams">Save</button>
              </div>
            </div>
            <!--./Manage Storefront teams-->

                <div class="row margin-top-2" style="padding-bottom:0px; margin-bottom:-5px;" v-if="isOwner">
                  <div class="sixteen wide column">
                    <h3 class="ui horizontal divider header">
                      <i class="sliders horizontal icon"></i>
                      Manage User Alerts
                    </h3>
                  </div>
                </div><!--.row-->

                <div class="row centered" v-if="alertMessage">
                  <div class="ui positive message transition" style="width: 100%;">
                  <!-- <i class="close icon"></i> -->
                  <div class="header">
                    {{ alertMessage }}
                  </div>
                </div>
                </div>

                <div class="ui column centered grid" style="width: 100%;" v-if="isOwner">
                  <div class="column row sub-heading">Optimize your teams performance, by customizing indivual user alerts, warnings and product improvements.</div>
                </div>
                <div class="row" v-if="isOwner">
                  <div class="two wide column">
                    <!-- <h4 style="padding-top:30px;" v-bind:class="emailDirty ? 'changed-color' : ''">Storefrant</h4> -->
                  </div>


                  <div class="four wide column">
                    <div class="ui field">
                      <label>Select User</label>
                      <select ref="alertUser" class="ui search selection dropdown" v-model="alertUser" v-on:change="onAlertUserChange">
                        <option value="">Select user</option>
                        <option
                          v-for="u in tenantUsersForTeamAndAlertsDropdown"
                          :key="'alert-user-' + u.id"
                          :value="u.email"
                        >
                          {{ formatTenantUserDropdownLabel(u) }}
                        </option>
                      </select>

                      <!-- <select class="ui fluid search dropdown" name="helpModalMarketplace" v-model="storefrontUsers">
                    <option v-for="(ea, i) in emailAddresses" value="ea.email}">{{ea.email}}</option>
                  </select> -->
                    </div>
                  </div>
                  <div class="four wide column">
                    <div class="ui field">
                      <button style="margin-top:25px" type="button" class="ui labeled icon button borderButton" v-if="isOwner && alertUser" v-on:click="manageAlertSettings = !manageAlertSettings"><i class="sliders horizontal icon"></i>Customize Alert</button>
                    </div>
                  </div>
                </div><!--.row-->

                <div class="ui column centered grid" v-if="manageAlertSettings && alertUser" style="width: 75%">
                  <div class="ui divider">
                  </div>
                </div>

              <div class="row" v-if="manageAlertSettings && alertUser" >
                  <div class="two wide column"></div>
                  <div class="twelve wide column">
                    <table class="ui very basic compact table">
                        <tbody>
                          <tr>
                            <td class="six wide">Enable all email alerts</td>
                            <td><input type="checkbox" v-model="enableAllAlerts" v-on:change="onEnableAllAlertChange"/></td>
                          </tr>
                          <tr>
                            <td class="six wide">Disable all email alerts</td>
                            <td><input type="checkbox" v-model="disableAllAlerts" v-on:change="onDisableAllAlertChange"/></td>
                          </tr>
                        </tbody>
                    </table>
                  </div>
              </div><!--.row-->
              <transition name="fadeDown">
                <div v-if="manageAlertSettings && alertUser" v-for="(ea, i) in alertUserList"  class="ui sixteen wide column">
                  <div colspan="4" style="padding-top:10px;padding-left:40px;padding-right:20px">
                    <div class="ui centered segment">
                      <table class="ui striped very basic table">
                        <thead>
                          <tr>
                            <th style="color:purple; padding:10px;">
                              <small>A more detailed description of each alert type is available
                                <br> in the [Issues] section, under the [info] tab of each box.
                              </small>
                            </th>
                            <th width="80px" style="color:red;">
                              <i class="warning circle icon"></i>
                              <span style="text-decoration:underline;text-decoration-style:dotted;"
                                    data-inverted
                                    data-tooltip="Alert: An issue that needs your attention."
                                    data-position="top right">
                                Alert
                              </span>
                            </th>
                            <th width="80px" style="color:orange;">
                              <span style="text-decoration:underline;text-decoration-style:dotted;"
                                    data-inverted
                                    data-tooltip="Warning: A lesser important issue."
                                    data-position="top right">
                                Warning
                              </span>
                            </th>
                            <th width="85px" style="color:green;">
                              <i class="checkmark circle icon"></i>
                              <span style="text-decoration:underline;text-decoration-style:dotted;"
                                    data-inverted
                                    data-tooltip="Improvement: A positive change."
                                    data-position="top right">
                                Imprv.
                              </span>
                            </th>
                          </tr>
                        </thead>
                        <tbody>
                          <tr v-for="wdt in watchDogTypes"
                              :key="wdt"
                              :class="{ 'greyed-out': isSuppressed(wdt) }">
                            <td style="padding-left:10px">
                              Subscribe to "{{ watchDogTypesToDisplayName[wdt] }}" Emails
                            </td>
                            <td class="center aligned">
                              <input type="checkbox" data-lpignore="true"
                                    v-if="ea.alertsSettings && ea.alertsSettings[wdt]"
                                    v-model="ea.alertsSettings[wdt]['RED']"
                                    :disabled="isSuppressed(wdt)" />
                            </td>
                            <td class="center aligned">
                              <input type="checkbox" data-lpignore="true"
                                    v-if="ea.alertsSettings && ea.alertsSettings[wdt]"
                                    v-model="ea.alertsSettings[wdt]['AMBER']"
                                    :disabled="isSuppressed(wdt)" />
                            </td>
                            <td class="center aligned">
                              <input type="checkbox" data-lpignore="true"
                                    v-if="ea.alertsSettings && ea.alertsSettings[wdt]"
                                    v-model="ea.alertsSettings[wdt]['GREEN']"
                                    :disabled="isSuppressed(wdt)" />
                            </td>
                          </tr>
                        </tbody>
                      </table>
                      <table class="ui striped very basic table">
                        <thead>
                          <th></th>
                          <th width="160px">Team Setting Defaults</th>
                          <th width="80px">&nbsp;</th>
                        </thead>
                        <tbody>
                          <tr>
                            <td style="padding-left:10px">Subscribe to Daily Digest Email</td>
                            <td style="padding-left:35px;"><input type="checkbox" data-lpignore="true" v-model="ea.subscribedToDailyDigestEmail"/></td>
                          </tr>
                          <tr>
                            <td style="padding-left:10px">Subscribe to SentryKit Product Updates</td>
                            <td style="padding-left:35px;">
                              <span>
                                <input type="checkbox" data-lpignore="true" v-model="ea.subscribedToNewsletter"/>
                              </span>
                            </td>
                          </tr>
                        </tbody>
                      </table>

                      <daily-digest-timing :emailAddress="ea" v-on:digestTimingUpdated="ea.updateDigestTiming"/>
                      <h4 v-if="emailDirty" class="changed-color">* The settings have changed, click Save on the bottom of the screen.</h4>
                    </div>
                  </div>
                </div>
              </transition>
              <div class="ui container" v-if="isOwner">
                <div class="ui clearing">
                    <button v-bind:class="emailDirty ? 'ui right floated primary button' : 'ui right floated primary disabled button'" v-on:click.prevent="save('alerts')">Save</button>
              </div>
            </div>
            <!--.manage user alerts-->
            <div class="row margin-top-2" style="padding-bottom:0px; margin-bottom:-5px;">
              <div class="sixteen wide column">
                <h3 class="ui horizontal divider header">
                  <i class="sliders horizontal icon"></i>
                  Manage Email Channel Alerts
                </h3>
              </div>
            </div><!--.row-->
            <div class="ui column centered grid" style="width: 100%;" v-if="isOwner">
                <div class="column row sub-heading">Set up team notification channels, like Slack or Teams, for group alerts.</div>
            </div>
            <div class="row">
              <div class="two wide column">
                <h4 style="padding-top:30px;" v-bind:class="emailDirty ? 'changed-color' : ''">Email Alerts</h4>
              </div>
              <div class="fourteen wide column">
                <table class="ui very basic table emailSettingsTable">
                  <tbody v-for="(ea, i) in emailAddresses" v-if="!ea.isDeleted && (!ea.isUser||ea.isPrimary) && (isOwner||ea.isPrimary)" :key="ea.emailAddressId">
                    <tr>
                      <td class="seven wide" v-if="!ea.isNew && !ea.isPrimary">{{ea.email}}</td>
                      <td class="seven wide" v-else>
                        <div v-bind:class="ea.emailValid ? 'field' : 'error field'">
                          <input v-model="ea.email" name="emailaddrs" data-lpignore="true" required="required" maxlength="100" class="ui input focus" />
                        </div>
                      </td>
                      <td class="five wide">
                        <div style="min-width:90px;text-align:center;margin-right:10px;background-color:#fff !important;" v-bind:class="ea.emailVerified && ea.email === ea.originalEmail ? 'ui green basic label' : 'ui red basic label'">{{ea.emailVerified ? 'Verified' : 'Not verified'}}</div>

                        <button data-tooltip="Resend Verification E-Mail" type="button" v-bind:class="!ea.emailVerified && !ea.isNew && !ea.verificationEmailSent && ea.email === ea.originalEmail ? 'ui tiny icon button' : 'ui tiny icon disabled button'" v-on:click="resendVerification(ea)">
                          <i class="mail icon"></i>
                        </button>
                      </td>
                      <td class="five wide">

                        <div v-if="i==0" :class="{'alertSettingsAni' : alertSettingsAni}"></div>

                        <div class="ui labeled tiny icon button borderButton" v-on:click="ea.manageSubscriptionSettings = !ea.manageSubscriptionSettings">
                          <i class="sliders horizontal icon"></i>Manage Alerts
                        </div>

                      </td>
                     <!-- <td class="five wide" v-if="!ea.isUser && isOwner && !ea.isNew">

                        <div class="ui tiny green icon button" v-on:click="openConvertIntoUserModal(i)">
                          Convert into user
                        </div>

                      </td> -->
                      <td class="five wide" v-if="ea.isUser && !ea.isPrimary && isOwner">
                        <div class="ui labeled tiny orange icon button" v-on:click="ea.manageSellerPermissions = !ea.manageSellerPermissions">
                          <i class="cogs horizontal icon"></i>Manage Permissions
                        </div>
                      </td>
                      <td class="one wide">
                        <i v-if="ea.isPrimary">Account Login Address</i>
                        <div v-else class="ui tiny icon button" v-on:click="deleteEmailAddress(i)">
                          <i class="trash alternate outline icon"></i>
                        </div>
                      </td>
                    </tr>
                    <transition name="fadeDown">
                      <tr v-if="ea.convertIntoUser" style="max-width: 500px;">
                        <td colspan="4" >

                        <div class="ui segment">
                          <form class="ui form" action="javascript:void(0)">
                            <div class="field">
                              <label>Name *</label>
                              <div class="two fields">
                                <div class="field focus">
                                  <input type="text" v-model="user.firstName" name="firstName" :placeholder="$t('First Name')" required="true" autofocus="true" >
                                </div>
                                <div class="field">
                                  <input type="text" v-model="user.lastName" name="lastName" :placeholder="$t('Last Name')" required="true" autofocus="true" >
                                </div>
                              </div>
                            </div>
                            <div class="field">
                              <label>{{ 'Email *' | translate }}</label>
                              <input id="email" type="email" name="email" v-model="user.email" :placeholder="$t('Email')" readonly="true" />
                            </div>

                            <div class="ui tiny blue icon button" v-on:click="convertIntoUser(i)">
                              convert
                            </div>
                          </form>
                        </div>
                        </td>
                      </tr>
                    </transition>
                    <transition name="fadeDown">
                    <tr v-if="ea.manageSubscriptionSettings">
                      <td colspan="4" style="padding-top:10px;padding-left:40px;padding-right:20px">
                        <div class="ui segment">
                          <table class="ui striped very basic table">
                            <thead>
                              <tr>
                                <th style="color:purple; padding:10px;">
                                  <small>A more detailed description of each alert type is available
                                    <br> in the [Issues] section, under the [info] tab of each box.
                                  </small>
                                </th>
                                <th width="80px" style="color:red;">
                                  <i class="warning circle icon"></i>
                                  <span style="text-decoration:underline;text-decoration-style:dotted;"
                                        data-inverted
                                        data-tooltip="Alert: An issue that needs your attention."
                                        data-position="top right">
                                    Alert
                                  </span>
                                </th>
                                <th width="80px" style="color:orange;">
                                  <span style="text-decoration:underline;text-decoration-style:dotted;"
                                        data-inverted
                                        data-tooltip="Warning: A lesser important issue."
                                        data-position="top right">
                                    Warning
                                  </span>
                                </th>
                                <th width="85px" style="color:green;">
                                  <i class="checkmark circle icon"></i>
                                  <span style="text-decoration:underline;text-decoration-style:dotted;"
                                        data-inverted
                                        data-tooltip="Improvement: A positive change."
                                        data-position="top right">
                                    Imprv.
                                  </span>
                                </th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="wdt in watchDogTypes"
                                  :key="wdt"
                                  :class="{ 'greyed-out': isSuppressed(wdt) }">
                                <td style="padding-left:10px">
                                  Subscribe to "{{ watchDogTypesToDisplayName[wdt] }}" Emails
                                </td>
                                <td class="center aligned">
                                  <input type="checkbox" data-lpignore="true"
                                        v-if="ea.alertsSettings && ea.alertsSettings[wdt]"
                                        v-model="ea.alertsSettings[wdt]['RED']"
                                        :disabled="isSuppressed(wdt)" />
                                </td>
                                <td class="center aligned">
                                  <input type="checkbox" data-lpignore="true"
                                        v-if="ea.alertsSettings && ea.alertsSettings[wdt]"
                                        v-model="ea.alertsSettings[wdt]['AMBER']"
                                        :disabled="isSuppressed(wdt)" />
                                </td>
                                <td class="center aligned">
                                  <input type="checkbox" data-lpignore="true"
                                        v-if="ea.alertsSettings && ea.alertsSettings[wdt]"
                                        v-model="ea.alertsSettings[wdt]['GREEN']"
                                        :disabled="isSuppressed(wdt)" />
                                </td>
                              </tr>
                            </tbody>
                          </table>

                          <div v-if="!isEmptyObject(filteredSellers)" class="twelve wide column">
                            <h3>
                              Seller accounts subscribed
                            </h3>
                            <table class="ui very basic compact table">
                              <thead>
                                <tr>
                                  <th class="three wide">Seller ID</th>
                                  <th class="one wide">Region</th>
                                  <th class="four wide">Account nick name</th>
                                  <th class="four wide">Subscribed</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="seller in filteredSellers">
                                  <td>{{seller.sellerKey.value}}</td>
                                  <td>{{seller.region}}</td>
                                  <td>{{seller.nickName}}</td>
                                  <td style="padding-left:35px;">
                                    <input type="checkbox" :checked="ea.unsubscribedSellerAccounts.indexOf(seller.sellerId.value) === -1" @click="checkSubscribe(seller.sellerId.value, i)"/>
                                  </td>
                                </tr>
                              </tbody>
                            </table>
                          </div>
                          <table class="ui striped very basic table">
                            <thead>
                              <th></th>
                              <th width="160px">Daily Digest</th>
                              <th width="80px">&nbsp;</th>
                            </thead>
                            <tbody>
                              <tr>
                                <td style="padding-left:10px">Subscribe to Daily Digest Email</td>
                                <td style="padding-left:35px;"><input type="checkbox" data-lpignore="true" v-model="ea.subscribedToDailyDigestEmail"/></td>
                              </tr>
                            </tbody>
                          </table>
                          <table class="ui striped very basic table">
                            <thead>
                              <th></th>
                              <th width="240px">Product Updates</th>
                            </thead>
                            <tbody>
                              <tr>
                                <td style="padding-left:10px">Subscribe to Product Updates</td>
                                <td style="padding-left:35px;">
                                  <span v-if="!ea.isPrimary">
                                    <input type="checkbox" data-lpignore="true" v-model="ea.subscribedToNewsletter"/>
                                  </span>
                                  <span v-else>
                                    <input type="checkbox" style="margin-top:3px;" checked="checked" disabled="disabled"/>
                                    <span data-tooltip="For the Primary Email address Product Update messages are always on.">
                                      <i class="ui question circle icon"></i>
                                    </span>
                                  </span>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <daily-digest-timing :emailAddress="ea" v-on:digestTimingUpdated="ea.updateDigestTiming"/>
                          <h4 v-if="emailDirty" class="changed-color">* The settings have changed, click Save on the bottom of the screen.</h4>
                        </div>
                      </td>
                    </tr>
                  </transition>
                  <transition>
                      <tr v-if="ea.manageSellerPermissions">
                        <td colspan="4" style="padding-top:10px;padding-left:40px;padding-right:20px">
                          <div class="ui segment">
                            <div v-if="!isEmptyObject(sellers)" class="twelve wide column">
                              <h3>
                                Seller accounts Permission
                              </h3>
                              <table class="ui very basic compact table">
                                <thead>
                                  <tr>
                                    <th class="three wide">Seller ID</th>
                                    <th class="one wide">Region</th>
                                    <th class="four wide">Account nick name</th>
                                    <th class="four wide">Access</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="seller in sellers">
                                  <td>{{seller.sellerKey.value}}</td>
                                  <td>{{seller.region}}</td>
                                  <td>{{seller.nickName}}</td>
                                    <td style="padding-left:35px;">
                                      <input type="checkbox" :checked="ea.allowedSellerAccounts.indexOf(seller.sellerId.value) !== -1" @click="checkSellerAccountsAccess(seller.sellerId.value, i)"/>
                                    </td>
                                  </tr>
                                </tbody>
                              </table>
                              <h4 v-if="emailDirty" class="changed-color">* The settings have changed, click Save on the bottom of the screen.</h4>
                            </div>
                           </div>
                        </td>
                      </tr>
                    </transition>
                  </tbody>
                </table>

                <button type="button" style="margin-top:-10px" v-if="isOwner" v-bind:class="addEmailAddressInProgress ? 'ui loading button' : 'ui  labeled icon button borderButton'" v-on:click="addEmailAddress()"><i class="add circle icon"></i>Add New Email Channel</button>

                <div class="ui basic segment">
                </div>
              </div>
            </div>

            <!-- Account Settings-->
            <div class="row marginBotton-1 margin-top-2" >
              <div class="sixteen wide column">
                <h3 class="ui horizontal divider header">
                  <i class="setting icon"></i>
                  Account Settings
                </h3>
              </div>
            </div><!--.row-->
            <div class="ui column centered grid" style="width: 100%;" v-if="isOwner">
                <div class="column row sub-heading">Manage your account-level email settings affecting all users. You can connect a <br>third party app, set your instant or batched alerts and alert email settings.</div>
            </div>
            <hr style="width:40%;" class="marginBotton-2" v-if="isOwner">
            <div class="ui column centered grid" style="width: 100%;" v-if="isOwner">
              <h3>Connect third-party apps</h3>
            </div>
            <div class="row" v-if="isOwner">
                <div class="sixteen wide column">
                  <div class="ui placeholder segment">
                  <div class="ui two column very relaxed stackable grid">
                    <div class="column">
                      <div class="row" >
                        <table class="ui striped very basic table">
                          <tbody>
                            <tr>
                              <td style="width: 100px;"><img src="data:image/png;base64,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" width="70px"/></td>
                              <!-- <td style="width:50px;">Zapier Alerts</td> -->
                              <td><a v-bind:class="zapierAuth && zapierAuth.length > 0? 'ui labeled icon button borderButton': 'ui labeled icon button'" target="_blank"
                              href="https://zapier.com/engine/auth/start/App240321CLIAPI@1.0.0/?_zapier_account_id=4400475"><i class="plug icon"></i>
                              Connect Zapier</a></td>
                            </tr>
                          </tbody>
                        </table>
                        <!-- <div class="five wide column">
                          <a v-if="!hasZapier" class="ui labeled icon button" target="_blank"
                              href="https://zapier.com/apps/sentrykit/integrations"><i class="plug icon"></i>
                              Connect Zapier</a>
                        </div> -->
                        <div class="six wide column" v-if="zapierList.length > 0">
                          <span >Check out all the </span>
                          <a href="https://docs.google.com/document/d/15O8b4mBsAb7ccIrL05jcxJCuo9_kDemcXkgjwMy_VA4/edit?usp=sharing" target="_blank" >triggers</a> you can use in your SentryKit Zaps.
                        </div>
                        <br>
                        <table style="margin-top: 1rem;" class="ui striped very basic table" v-if="hasZapier">
                        <tbody>
                            <tr v-for="z in zapierList">
                              <td style="width: 100px;">Added at {{new Date(z.timestamp).toLocaleDateString()}}</td>
                              <td><div v-bind:class="a.clicked ? 'ui primary button' : 'ui button'" v-on:click="deleteAuthorization(z)">{{z.clicked ? 'Confirm revoking authorization' : 'Revoke authorization'}}</div></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div> <!--.Zapier-->
                    <div class="column">
                      <div v-if="gsheetsConnection.enabled && isOwner">
                      <div v-if="gsheetsConnection.email" class="five wide column">
                      <table class="ui striped very basic table">
                        <tbody>
                          <tr>
                            <td style="width: 100px;"><img  width="100px" src="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAaQAAADICAYAAACnDZWgAAAgAElEQVR4Xux9CZwcRfX/e92zu9kNhJzkIEASThHQkAPklEsFBQ8gch8BstmZJYSQnZlNQAcSkp3eXCQ7uwkq+EdFkwCiIOKBiPrzREEUFZR4QDiSAOHIXtPd9f+8nu7dnp4+qmd69uzyB+SXqXr16nV1ffu9egeCR0ulUsLkyZPF/x0uTtldoYxTUUEaIqKg/ddoClMZ/VnQ/6vqvzv3ExlAFgAqYOjSzMmqV0a05l4Z0Z/NcjpcGftWw+nz/gMIWr+whRIIJRBKYDhJIO/ANC/8khdSlRPem3AYqpGPK0y9jClshhARx6mgAmOAzHJmIiAgYt5Byhhz6EeDzVOz4UmTMSBJMGDIGIPpIya8K4BwU2LORdutshxOmzJcayiBUALDUwK2gLTglxsOqYCqcwCE5e3ZzkP3dL4nvK90YmdXJygGxNBhamqIBEnUDJI5yKKD1tJR62H0pt+op9ZriNCkNTNV1SHbvP7cqu3WTmM+fegcGBmpfk2VO87tfuJf/0ilUurw3JbhqkMJhBIYjhIoAKTbfnvfEW9nu3+yp33v1H+8u1N8P9uhHaKhDYl/exSAsMNQDYZ1wRJ8XX7Y6TBx5BjozmZ3ggp1ybkXP8o/a9gzlEAogVACg1sCeYB0+x++PXNP17ubXtq785Qd776Rp+8M7mX2Lfd2gGQH6HaANGm/saCqKnTL8k7ozl7Q9eMX/5JKpeS+XUE4WyiBUAKhBPpeAj2AlPjVPR/erXb/+oU3d4za1f1+3g1P37M1uGcsFZA0kx9jICvKLqaqDck5l9w/uCUSch9KIJRAKAFvCWiAtPr5x8b8Z+//bnv2zX8u2dX1Pgjo6OvgTTHsUXhv5mDyNGtI9OfLDjsdSEMyAI3+m5WVPYqsXJ594m9PhZpSuLlCCYQSGMoSQHLrfvX0sclXOt6+86W9O8UQikp/3MVoSHaARJxooKSo7wFT70jOvnhd6dyFFEIJhBIIJTAwJYDNf75/5DNvvPbM3/buPHqf3DkwuRxkXPkCJH1tNMaqIRnL1jWldxmT67p+8PftoaY0yDZEyG4ogVACXBLARb/YfPYf3/7PEzs/2BMJTXVcMvPsFDQgGRNmZbmDMXZrcvbFbZ5MhB1CCYQSCCUwyCSA1z21sfZ3b764uUPpDh0ZAnp45QIkYq87K7+tKvL1h/8XH503b54SEMshmVACoQRCCfS7BPCU7zfe9fr7e5b1OydDiAErIDnFcJmzXbiZ7KyiyWazHzAVLg/jlIbQpgmXEkoglADgrIcXr327Y9+S0JkhuN1QbkDK3SnJrzPGLu/6wQu/CDM6BPfsQkqhBEIJ9J8E8ENbb1rfKXcuDgEpuIdQDCCpLJepwez27cVRd3f3XgT2ycSceb/36hv+HkoglEAogYEuAZz+YPRu7MouGuiMDib+eACpx1xnSR3kB5D0O6WdKlOi3T/422OhpjSYdknIayiBUAJWCYSAVIY9wQNINK05MFYBBlf41JAM1ru7s+8CwwuTcy76ZVi6ogwPNCQZSiCUQJ9IIASkMoiZB5DMYEQslAJIOU0pu4sxdcVh/4a20PuuDA81JBlKIJRA2SWAMx5euAE6lJvLPtMwmcC3y3eJJjtDrHruu3aVqZ9vnH3Jj4eJuMNlhhIIJTCEJIAzHly4DrqUW4bQmvp1KXZ1nRwzfefsdlozyk/4vUMyAxJpXYqsvsFAXdU564VMCsN6Sv26GcLJQwmEEvAlAZzxcN1a6JCX+BoVdnaUAI+GlFdtlwAJARRVhSsOP8OXl52ZCfO8WVl+jynq5xtPnPez8FGFEgglEEpgsEgAD3souoZ1Zm8dLAwPdD65749M2lHQgESks7LyNlOhsXHORV8JHR0G+q4J+QslEEqAJBACUsD7gAuQqFS7pQyvwoLTkAysozRD3XLHuamPXfWngJcZkgslEEoglEDgEghNdgGKlMdclwML/eLIdLkUNCAZy8rK2TcZw9hh/1YfCb3vAnzYIalQAqEEApdA6NQQoEh5AMnu/ojwqVyARJgny9nXVLnr3MYTr/g7Ijql1gtQEiGpUAKhBEIJ+JdA6PbtX2aOI7jMdYZ2ZFBhOY2JUgcV69RgB4RmJlWmgqyoO0HBm5Jzv/BICEoBPvSQVCiBUAKBSSAMjA1IlDzakWauM98f6QkE6e8UxuDKIr3svAApZyYEyGazr2G261OdP/7XC2GaoYAefEgmlEAogcAkEAJSQKLkBiSCBt3Vu/cqqfyAZCyzu1vehQxXJude1BJ63wX08EMyoQRCCQQigRCQAhGjrvlYaDkGxJp/wNzYcmtIJgshyLKyR5GVy7NP/O2psBx6QBsgJBNKIJRAyRLAGQ/VrYdOeXHJlIY5AV/3RwYg6a7f5b5DMj8ampoxFRRF/UCVoaX7xL8uDzM69P3mTaVS+3V0dCxkjF0FAJMAoBoAKgBA1P8xmKKqwJ0A8AEi/iQSibTdddddv+17jsMZQwmUXwKh23cAMuY211njj3TtiFgop1ODFZCM/1+Wlb2qql7f/fgL3w81pQA2ggeJ22+//biurq67AeB4ABgDAEKRs+4FgP8KgrBxxIgR94fPrkgpDvFhqVRqVEdHxymCIGi31aqqMkSkDxxVEASmqurbTU1Nzw4kMYSBsQE8DW5Asok/MtzAiwUkHocGJ0DSNCVZ7WQqSzfOveSO8E4pgM1gQ6KhoeFaREwCwBElgJATc28g4uOiKN62atWq18uzgpDqYJTAsmXLPirLshvg/J8kSacOpLWFgFTi0/ANRjSf6Q6pPwHJpCm9rSC7/IiX1Z+GwbMlbgjT8IaGhtMAYD0izgqOqiOlDxiyzSOrRy5PpVLdfTBfOMUAl0AymZypqqpblpYQkAb4M/TNnm9AsgGjUkx2fjQkp4hYXVN6jzH15sY58/5fqCn53gZ5A7Zt2yY+88wztwFAqjRKRY3ewxi7uLm5+emiRoeDhowEBiUghdm+S9t/RQOS6f6oWEDyA0YWxcx20dms/IYgwgXxmRf9MQyeLW5fNDY2jlMU5Q8AML04CoGNukmSpJbAqIWEBp0EEonERxhjz7kwPvA0pNDLrrR9Viwg5aUQKtKpIWhA0jSlrLKXoXBJ45yLflqaZIbfaI4v0j4VCiJub2pq+mL4cdGnYh8wky1btux4WZb/PKgAafqD0buxK7towEhxEDHCDUY22b1z5rNeI1oxcUhBA5LGkZ5miKnqFYf/B34V3inxbchkMnmRqqoP8vUu6JWllIOI+G/G2A5E3AUAI1RVnYKI5JE3Klc1S3MJ99vukSSp1u+gsP/gl8CyZcuOlWX5LyEgDf5nybUCbkAysjPoVK3aEf11uQHJT0ZVDZSyyrsqU7+4/MQv/ohLGMO4U0NDwzJEvMunCBRBENoOPPDA+JIlSzp4xjY2Nh6tKMoTAHAoT38A+Gc6nT4q1JA4pTXEuoWANMQeqNtyfIGRWRmy3B0ZcwwkQDI0JUVRdwHgLZ2P/eXB0HPLfjfEk/EGUEHysfX/KYrihatXr/6HjzHWrphMJu9QVXW5ixv5/yRJmpbv01nCjOHQQSeBQQlIMx5euAE6lJsHnbT7meGiAclcD8m0Br9xSOUw15lFSloSWYkUWWlXgF2/fM4l3+lnkQ+46ROJxGcZY4/wMIaI+1gFmyOtlP7O05+nz4IFCypGjx7dBgDXm/sj4s4dO3Ycun37dgqCDNswlUAikTiOMfa8y/IHoFPDgwvXQZdyyzB9ZkUtWzN/0b2QqTm6VFvMdTllqbA3aUiXTT0RDho/JZcR3KPx9OHhz3seSjPE9jLG7hz5m9daFy1a1OU1Zjj8vnHjxqpXX331XQCo8lovIn59x6wdN2yfVx6AiMfjHwKA3wHA/oj4ant7++GbNm0Kn5PXgxnivw9Kp4bQ7dv/rvStHZmBywFsSEM6beIxMHfyUZ6A1FdgpEGnzq8sK50IcGlyziXf8y+xoTciHo/v4HHtFgRhaVNT09pySyCZTI5RVfUbNTU1V6ZSKUotFLZhLoEwU8Mw2ABOYGDVaTQtyFJmgvyk3MBsWvVY+NwRp2nuVG6tbwHJ4IRpmhIwdtuMf6ubh7P3XTKZ/JSqqj/02u4KstvXpptXevULfw8lUA4JcIQhDDyT3WEPRdewzuyt5RDIUKTpSzuyqXtkJxMDzCIKg/lHnQMja/brZ0DqhdeceRIAETUwVVX1nWxWufC2k+b9aig+X541xeNxctOOeHw0PNrc3HwhD72wTyiBckggBKRySHWA0eQpM5E7w/VD3QRKdndH+nmvrTKrKnB0zTi48MgzAgMk79soZ4g0wqdyKltOb8uVrlDeVJlQf/i/le8ON00pmUxepqrqAx7b8l1JkkYPsK0bsjPMJDAoTXYzQqcG7m3Kqx0VAJI+gxcgaRpIVoGbZ34WKkT7D/C+NNdpGKQa4bs5aEMUcsGzsvp6lnWfe/ucy/42jOJcMB6Py14Zu5UKZdrau9b+l3tjhR1DCZRBAoPUqSF0++bZC77ByGyuc7g7MmtHBg+yqsCcsYfBaQcfByLml8vxC0Z29PnWmnP5zgFQbkTOt8EKSso7CHBFYvbFTwwHUEomkzNUVX3ZQ4ZPS5L0cR45h31CCZRTAoPS7TtMHeS9JXgdGQxK9uBlbzwrcIZgDLraO+HTh82B4w88LI85v4BUjLkuF39kNOy5O8qrmZGnKSmvQVb+TNePX/xzKpUyD/YW7CDrkUgkXmCMHePC9r6adM2osALvIHuwQ5TdQRkYGwKS+270A0Y9ffXS5JqSoTnb8YGRwYlK9zRdMnxs9GFw0ozjobKiQnMo6AtAMkuDwClnotMKn+cJiv4+pzmR+U55HwEakrMvuWeolq5YvHjx6MrKync8zq7vSJJ02RA93zyX1dzcPDKbzY7obux+Z6CBMlVPraqqEhuTjXsH2h6lcvapVOoDTwH77NCXgLRt27bKP//5zxPHjRu3hzcVlt1yMASkAAEpv/JeD2E/gGSAjioroOzrgjljp8FJR50AIyJVnu7geWDic/Ma4NKjG+l3RTnvOlKJdDd2vYMZkFSVwBL2KLJyefaJvz01FEtqx+PxuXrwqbNka+BgKSW9WoToB92QeDz+ZURcwhijxK92jbRl+oeyRWzsqOlYuSm16b0+WCgmEolbGWOUVml//b7PGklBO5p4o4S29xx00EENfRHwnUqlatrb278EAIv1RLmULNcuymOXIAgLm5qavmuW15YtWyqc5Pf6668z63tXTkBKJpO3qKp6BwAYLsHmdZi/YJ8UBGFBU1PTf3iePYblJ5zF5Es7ssnI4BR3pB3+DtOa5yQgY1kVsm/vgxkVY+FjH5oJUw+cDKJYTNLn3ISqNnMxxjx7hg0LH/GtqOw9JittXXNfWDbQvpB5Xga3PvF4/NsAcKlLn99KkvSxUucZyONTqdSU9vb2/wOAg4vIPK4iYoeqqtHm5ub7g15nKpWatG/fvscQ8Vie7BmW+emFeIcxdk1zc/NjQfOme7tRQPlBPuX2PiJekU6nHyWePMINfi1J0ilm3oO+Q0qlUpGOjo5fMcbmeDn22Mj3A0EQ5jU1NVFyYMeGYaYGf4Bkd5QXaEA9Ht/OB78tHZssDkRblVVQ3toHkX0yjBo1Cg4dOwmmHjABqquqQBBEzePAPFRzREAE+l9vy/XpCdilH5D+j+6J9P9H75zrY6KpkyFtKdfToJvrQyZGY0wW1fd+u+fZKc9f/Y19Qb/Y/UVPrwDb6RZ7JAhCS1NT0039xWM5502lUpXt7e1bAYDiqvI9bYqYmHLtAcCn0+m0W60eLsrxeJzSJX2DMXYeAFRyDXLv9D9RFOetXr2aUjGV1hhgPBH/OQBQKXuveHe3uZ6SJOmseDxO2qat/Bljf2hubiYtvqcFWaAvkUjcxhijKsieqbI8hPbbmnTNKU4frBgGxtqLz7d2RGQMlCny7sh5TgZMZaC2ZwHeaofuru58phXdl0AHGE0zI/CQ9dyaEbH3zwXvhRNo2r0/7n1VRQGsFBVxxpQxe66/9/3S3uaBMzqRSBzAGHNNxyMIwsVNTU0PDRyug+GksbHxGEVRKIHsEcFQNH0iMSY1NzcniqWbTCY/rqoqaVuksQXZulHATLopvaRYorHltx46MisSqE0sloZlHJWB+aQLrT9LkvRR8+9BxSElEokHGWMXBbQOIvPquHHjjkkkEgVnRAhINlIuCYx0en7ujQwWnF3Le5FOfr8DcB8lCgAQFKAgVc2EZx5Lmgz9PUR0UJHzgUQzoNOdEG8zAM+tP6lKggBMABknjR87lABp2bJlE2VZfsNVXJVwtLRSepFXpIOh362JxKkiY5QiyT11SGmL2SxJUp1fEvF4/GIAuFe/J/I7nLf/I5IkfZ63s9Hvtttum97d3U1Z3UvVJvxM/VdJko4zDwggUwPdxz3AGHMzVfvh0dz37ZqamoNTqVS7+S9DQOIEJMc7H3NGBhMtv4DkHufUO7tmIvugE9QumWxledwbGMNslBsNvNDwykYQdPOb0Zep+m+Whdqu26Bvnt/4O0FQYOzooaYhHcIYcwt0VWpqakYE5cxBX7aKolBZCWqaAdbGVGNczFMfze1E708mHesOoIdrvjw0aK407iesr0EymZyjqiqZm2qKPXF4xwmCsKKpqYku+7laY2PjxxRF+RlV1eUaUEInxpivFFBLly4dKQgCeWM6OiCUwI7b0L9IkkTVhXtaqYAUj8frAWBTmfglsgUFJMM7JIu0S9KOeoJIS787Mk6ZHHtmejl7YPb9ToDOrH4UaZG3AAICKgzsAKnYTZVzgnBosg5igun8EwUZDxbG7J63PXA31mLXUOq4xsbGIxVFcdN+3pIkaXyp8xjjGxsbT1EUpey5AqksRjqdvs7KdyqVOrC9vf2vADCBc020EciDjv6hu0MCigMBYCTneIhEImetWrXqKa/+uvn0dQCo9uqr/052azK3kp2b/lyBiNUu3oEFZP1kbOfNAm9MQvdpjDGqGEyeSuQVOMan40PuhGDsj83NzbPNzJdyh8QBZuap6Pn/CxEJiN9njFHaLCoO6flOIOLd6XSavA61FnrZmcTqB4xyMNHjvZC3iYPQjnphyHwx1Tur5tW2rwtYpwxoAAJpLPRnMrFZMEy7U3JoaNG0OF903WPP0ltAGacOLUCKL4/PhaxWb8ip7ZAkKT+KmVeINv10DeDXJZDgHfq8JEkfMXdmjJGZ5hcAcCoHkX2IuG1fNbutJSW9Zu2fSCRqqY6WDk6e5GpqasZ4lc6Ix+PkPuxZwh0RCRzvra6u/nIqlcpzN0+lUkJXV9eFiqJs4KFFFu6amppxXrw1NjYuVhRlvedCAcjmvi0SiTSsWrWKwLWnpVKp0e3t7eROfYNP7fQ3kiSdbKZVbOqgxanFoyvbK9/icGBRGWMPjBw5stZqeiM+9AKW3/Qy+bJKdmTzyuZ/aoAUxiHlHqEfMMoDHIsjQx5QmXaH242Nt7nOiLTVedXpCoDQ9UEHYHdvYVBNQxJ1UBKEnPFGVoGZtRgTX8WCEZGw1Z6GIiB5xCAxxl5pbm4+hOMg4urS2Nh4oqIov+XqXFqnPZIk5WlBDQ0NNyMiHdRujbbzmtmzZzfyJNeNx+NXAcD/8/I0Q8SfptPpc50mTiQSpzLGfum1ZER8KJ1O0x2TZ9Npkmbmmr0dEd9Pp9NOMVewbNmyybIsF4CylQFE/GN1U/Vcr7AI3bOTZHaF5yJyHX4pSdLpFkA6Vpblv7iMty0/kUgkNjLGvDxGXxAE4bSmpib3YPGcpyFp+3lgaeHp7dmzZx9IeykEJF0yvnPV5ZAn1zy86sxdrZuDH4xyk9gBm9zeBdBJOT89TpEiNSE7qj13TpYfURRlOAiGlMmuoaHhBDpIXKT7viRJjoeV13Ox/r58+fK52Wy2dLdj74nfkSRprLlbPB7f5WWqEwRhblNT0x+8yff20A9sOhzHuY1zoU2JbT1TUyHiwnQ6vcUPbxRw+vLLL7/t9SVfWVk5Y+XKlf+2ox2Px0mrJPdux4aIq9LpNAXscrdEInEpY4xi4LxaQQ7FYgJjOczTxMdWSZJ8OTrE4/GfAsDZLov4hCRJPwkBKQjtSJdysKY6ImrcVffeWTvNIe/rBOjq1ZS8dq/2uxZu5MPbzkR0OAGSXiL8bx4H6VjPr0WuhwLQX4BE2RcAIOXGZiQSOWfVqlVPci4lr1sylZymtmvJad1imR6XJOnTVvo8WiMirkmn0w3F8Ebpe9rb29/0MJO9KUnSJCv9pUuXHi8IgntMlQBrpSZpaTG8JZPJTaqqkoOBW/uFJEl5dWuKAaREIrGOMXaLy0TPptPpWX6SKW/cuLHq1VdfXQcAURe6/5UkadqwB6SiTHU2Z7hfMNLwwAEMemnlJ8Vz9PTTfmCgdGUBKFaJt5UASI5TiCjD5KGlIfG4fTPGTm9ubvY0J/E8Gp7Dl4cOR588Z4x4PL7b7SKaMfZcc3PzTA66jl0SicQFjLHve4D7EU1NTf8y90kkEnsYY27a1bOSJJ1QCm/xeJwcPMiV3LGpqrrfmjVr8oK+E4nEWsaYY8wSIv4hnU7nBa364XMb2yY+k3jGywTyK0mS8jS0YjI1xONxClqe4sQfIo5Op9Pv8vC/fPnyk7PZ7HY3emY6iHg+Dud6SH7AKHfkW5wYijTVec9b6FWXm9++mempHd3AyCXc1JnulOhuKahm58XX43IugAyThhYg6ZkKujzk9yVJklYEIWM9oNG4xyFtwnDltuYLM/LFGSq0ua/Bils6oxclSTqaOqZYSmhPtNOh5+T9wmpqakYFkQR06dKl/xQE4XCXQ++qdDpNl+Fau+mmm6qqq6spU4ZTY2pEPX7NqjXkGVh00x06/gQAeQGmZoKCIJzZ1NRE7vBa08195DTh6IKuqurJa9as+U3RjOUcBM5jjD3uQqMgdZVfpwbd1f/3Ls9leTqdXuW1jng8LgHA9QCQZw72GgcAPxyWbt9uZirXQz9fYdHk66QZ5X6zb+6AVOhV55cWk1UtVklzZNDJ8TovaGDjkeQEyTJo6aMAA3KyAAEUNnL/IRWHRPKPx+OUg8sxUt7rQp7jZQy8i+6+TWYop9YT+JlIJC5njH3L5TD6IJ1Ok1tyya2xsfE0RVHozsWp5QXLcqzjT5IkzSqZsdzBfwdjzC0m6kFJki4x5orH4+Rq7Xaf9mZNTc2UIEqz6HdoTm9ngQz8ZmpoaGhYgYiUHsi21dTUVKVSKUuamFzXZDI5jTG2EQDO8ONSb0yEiOsjkcjdwzIw1ltDyX8eTu7dboDk16uuEHR6KRRDS+3Mgtqdr+UTKOVAKjhtqWDnIiqsZr+hB0jL4ueCDD92ObDfq66unmzn/hrEQVkMDa9y64i4OJ1O3020GxoafoqIjpfOxVzIO/F8yy23jK2oqCC3YqeW5/2VTCavVVX1Ppf+90iSVFuMjKxj9CwLdM/ldPATMI8y7lC8nA4Q8fZ0Or0yCN7i8ThpYk4fBSUHxiYSie8zxi5w4lWSpDyZ6NrhPAAgU6ebw4ITydcQcSUifse4fx12gOQXjPJAx3KOB6kd9QKS2ZGB/hbdtTAXcFG6ZWAUPGtuFj8JA6S0/5aS/tGYQ0CFVQ89QOIx2yFiIp1Ok7liQLR4PE53Wo7xRFVVVceuWLHiBWI2kUh0MMYczU6shk1uTjW7p0/iXPWCLQsqRr882vZLWyeRd7fV0NDwLUS83OVj4DPpdPoHnNN7dovH468AwFSnjjU1NRVGVo5EIpFkjK126isIQsF9mCcDDh0SicR9jLFrHX4uOXVQPB6n2DdbEy8i7k6n0xTsTB8vhyEiudXTR8D0ItbzS0TcnE6nH7COHVaAFAgYFXlvpAGOC3jksM5qrnMp7qc7MjhtBvpZK+rXmQVGSVbpL0g7srp+W28lcozmyFIwrd2f3XbgEAWkSy65RJw+fTpd5rplH+i5kyniJQ18SDwed1OFZUmSetLbeJiDmCRJJWf5Ni8wkUi862LaYel0WjS0kHhci2PJK61gpoWIHw0ic7hBMx6PkwkuL+uBeb6amprqVCql3WklEokNjLGbnR6eoijT1q5d65Z2ivu56zWIyFvNrj0nSVKew4lfk108HqfQBifHEArg/Rwixhhj9HHgGrdlwyBlo/h1JBKJr1q1iu7pbNuwcWooCozoMDYObM6Yo2LMa/nGud4Ji6FlPOW8sd0KKJ3dOUDq+cHs9cD9Tnh3JC+78eqQikMyFp1MJhtUVfXSgM6RJKkot2hv4fL30IvBuZUAyQuKjcfjZN91KrSVlSQpiNIOPQtYunTpc4Ig5GWJsBz6+xsOFPF4/CW3bOM1NTUTUqnUHn7puPeMx+PkPEDlLJzaKEmStEzV8XicvPIK0i+ZBh4sScEUbVy2bNmnZVl2qtf0e0mSTjQz7NepIR6PU5wY1ZMKqtEh8zZj7GuHH374bbW1tZ4uwDjj4YUboENxRPigOOsvOt5aiTNndl51xdDzivUpdPMmnoo31dkCWbcMZMJzbUEEzoqCDOOVIQlICxYsqBg92tXUROJ9I51OT/ETp1GOd8OrZAAifjedTn/BmDsej5MXoRPo5GlTQfAbj8cJQBzduGfPnh0xskC4mZKIF8bY4c3NzXTvE0iLx+NUhNAxs4DZ9Tkej1MS3IVOE4uieNTq1asJUEtujY2N1ymK4uSWXpB1wa/bdzwep2Dsot3TTQvsRsR/CYJw0erVq//hZ+FDOg6pGPDQN3ifaEbaXNrTMkOIc0YG48EWuy4lKwOQS7hTMwDJIc2Q47hc5b9cG8KARMvjiDgHRLw/nU5f4+dFDLIvh5s01NTUkANGz51QPB6nTAWU2NO2TZo0qWbJkiVkdim56ZfhjndIiNiZTqd7kqcmEoltjLEezzYrA6Iofnz16tVPl8yYTiAejxO4zXChZ9aQ1gDArU59BUGY3U+UL+0AACAASURBVNTU5Jblg5vtRCLRzBhzCq4tOTC2oaHhKUT8ODdDhR1lVVXXrlmzprHYstRDFpCKPbRz8KCfrpxmOiukmJ+Tfz7cXCWMKx17Yx6PiQ/JJTyraPdLgiiAahTxK2EX5q1XRBnHDk0NyVinx32LsR3mSpL0TEBi5SZDsTTJZPKvjLFjXAa9IElSnmkmkUg8zBhzrP3jJ+O1F7PLly8/KJvNvurS7xlJkqhMttb0JK2bnfozxpqam5vpECy5NTY2jlMUxc38p6TTacoYrr1uDQ0NNyDiV5wmRsT6dDqdKZmx3McQaRtHOdAqOXVQPB6nFEW+UgLpvLwpCMJ5TU1Nz5a6ziEHSN7mMWeRaWPNd0amnKZBe9TlAZ+RDE9njQdY7FbBO47S/lCW8BCQint9EonEvYwxt3sD7fHW1NQcGOTdBg+3Xoc30UDEL6bT6W1meh73E9Q1sHx9yWTyU6qqUuE/24aI96XT6fnGj7embh0vtouURcKpFQSF8sjKrk8ikVjKGGt2Gi8IwmNNTU09rtGJROJ0xpibdvayJEmOQcB++IzH46RVOtVZKllD8lq7hVeVQgGqm6q/7JUo1s8ah1T5Cf/aSL6o7OKN3PUV5+BX7UTi8qrL97V2BT6P+CEnQLLlg0pUkLZkFOYzm+uMP+cnGbfdV0z3vaLvRc1tnLJ9jxnaGhKVL2hvbzfq/ri9b3JFRcXhd911VyBeVl4v9pJkw0URFSlVi5sD/3PpdJqSxeZtF31NdI/k5D1FAFtZahFCfZ4dbmUfyIurubm5J6EojwkyEol8ZNWqVc97ycjr94aGhr8jopa9wq6ponrymtW9WRfWrVtX/cYbb1DtLzcvxDmlass3pW49prpd1Fz0HdqvJUnK80T0e4eUSCQ+zBjzynbxvCiKl6xevZrKRQQe0DgkMjWUohX1AEeAmpE3GFnvjLQRrk+32DW6giJpSl0yCFR6nFzEiwiYLeCaCvSNloekU4P5IFi2bNkJsixTmhUnzzSju4yIV1g1Eq+D0e/vjY2NcUVRKK2LFz9aVmU7+vF4nEoJUHE1p1ayJtLY2Eh1iL7ntr5IJDLFWifICygAoMAM6VeGiUSCXJpbXMaxvXv3Vt1zzz153mLxeJxMdlS/yLYh4iPpdNp3KXQzMa87PsbYH5qbm/McEvwW6NNTJ1EhyiN4AdmvjKl/PB6/RpIkKq1R0AZ1HBLPAeoF4ba1jTzhIQjNyHgWvfmIitWOeE11dhtAVRVg3QrQ9zKHQlRAwgaQFBCrh1ymBjvZJZPJb6qqylWvhgqZCYIQ5U1MyfuiL1++/FBZlr/KGDvHawwD9tVmqflGp34caXO4K7s6AB7df1BMkWMlUadaRl551vSv9TskSaLidr6bXh6Div+5ube/IklSQd0rDvdq+uira2pqcrwHc2M43hi/DhT3pK8A8GdJkvJy8PmNQyIeksnkSlVV3Upk7Mlms0etX7+enGB8t5sabz2mWtE0vRdFUfzC6tWr87LoD1pAKhWMCg7SABwY6Ol4m+m0XqYHWZpXnZWadYe4yynHh0omui6Z7hbyhpOMmIv1B0mrsup1ojBsAEk3P9EB65bAtEemernqNaqqfsWaMdrvm02eajt27PiSHpTJk2Puv2qNOndNag3VO7JtqVQq0t7eTlrSfi78kJvm8ZIk/d0Pz/F4nDIfUAyNY+wR0YtEIsetWrXK1mwUj8cpi6KbaYw29BckSXrED296WXRyGCgoLWGmo0bU4+wSuOpZPEizoLLdTq0dES9Np9OP+uGNp/SJTq/kTA1ER6+HRCDhqGkzgK0ja2qudspr57Q++njKZrPk+GB4czJEXLZjx47m7du3a7VzBiUgeYGRq8ZgPUALsaGohKl8YGRBPf3JeWpxnndR9luAB4yMkQRKlJRVSyvNAChZqmsjjcqGLybisAEkkk8qlRrV3t5O1V0/5OOgoQv65kgk8kOnw9eJFtXeiUQiF1PNGsaYG3CYSSiCIMzh8YLidNigLOOfqKmpeYonaWg8Hj+JSnYDwMFuMkLE382aNesUpyq0iUTiRsbYPV5yRsS8bOFu/Umeoij+kiMhaEF1XTNdfY1eGb07UcRF6VXpr2phhi6NzGcNDQ1nC4LwI45S4kSp5Fx2BjucFWOpBPuiVatWuSXv1UjSWhobG89QVfW7diZhxtjPRVG8rqmp6T+D7g4pMDCybgeOlECacN03keOvhfFGvV2LpenGj5ecrCshHpiiaqDE05yyhzPK1CBWj91z/b1aJPtwaLoXGB1GxXhTUd60+yECT6KCu7LZ7HuCIHRVVlaiLMsVgiBQfrlDVFX9IqVuAQAtn5iPxkRR/Nzq1atdaxD10MuVnCaXbMeaOEZf8jgDgFtGjBjxmjWpLGmPXV1dR8qy3ICI5JHolSmRnCamplIp1zLg8XickrJ6lTWgTfwcY+z6kSNH/sNI82OWmf61TuZLrgquoih+yC3Ik1JLzZgx41nG2HEcz+YFxtjVOm/t5v7kwDFy5MjJ5OnHGOMqw64f+n9sbm7OS3fk9w7JBEiHMMZIA67xWMvbgiAskGX5l2vWFGretJYRB4w4RMgKKT3dkBs58to7f1B42Xkfrt7uHo4mOhKRlrLNXSMIXoshil7ZGNwhsHggKxypARL9ixwdOEDJEZAigowHZIe8U4P1zdIrjpKTgx9NiePsKqkLmUSuTafT9/uhkkgkTtVdmXnz15G55Q+I+DfGGAEGHcpnAkAV77yCICxpampa79Vfv+shwOTljUj+HyI+R1k0qNYRY+wstyBgKw9UULC5ufmzXrylUqkR7e3tdLfSE9TrMoZkRmYxKmvyF0QUVVU9AhGpxEkxaZp+I0lSXnYJjrutguwOPaC0LPFpJjOnNEV2y9rFGKOM8TtFUaxRFOV4PduFl5ONQeuDSCRy5ICOQ9KOTQ7PL08TXe7sd0WtYuKMDEl63xsNXFOdHeQRIJG2VFSjwNhRww+QNFkxwEQysYkxRqWavTSCosTrYxA9wBOLdTfmqZ7qgxfXrqqq/qq5ufl03nRLiUTiSsbYN4Ka34PODkmSDuOdq7GxcYKiKGTG6uvn/0tJkk438+nX7du6xqVLl24SBMGrdDqvaNz6kUn5yKamph0DEpC8tJUeIOAQRYEXnQWYSokzyuGlMxz2/mIgYu7U8ta27GCid7HFa0aFdO1o5ZaUu1MqaF757oYzIOnCaljWcALKSFka+vpQMh5XdtKkSQeUmuonkUjMY4xt5XjNSunykiRJTtkHHOkmk8kFqqpuKWVir7GMsX80Nzf71njpvkRRlJ6qsl7zBPR7yZka7PgoIXsD97IYY5Obm3OlTQYUIPFqRO7HdU4OjkDEmX2Baw5PMApeM3Ljiw/I8yHIE9xIWzJvrRCQeF80upT+plsdH15CPvu1SJJ0k88xjt11ryvyICtH+7YkSY51jrwmTCaTM1VVpbs7btOgF03jd4Z4f3MJ+Qjjt8WPgm4gb0G/ZRqcWKRaRZROySlTQ1kAiZiJx+OkJW3ilZ2Pfp01NTUHmL31+hWQ+A7Q3uV5aRY9QJSvkPQS4HRcCB6MzGvwuKsq4S7Lj1ddz4vnsnsMTQkUPWjWC4zoQyCCsrD/MDXZ2chSLwNBWsZnfLyoxXT9zt69e6+2Bm0WQ8g6hi6na2pqHuOJdeKc732swo+lV6TdMg9wkdq2bZv4zDPPkPnuMq4BHp0Q8T1FUU5bs2ZNyVkfdAeF36uqSvcppbRfp9PpUxOJBGXScAKkX0mSdJp5klJNdmZanHFa3GtExDXV1dUJq5dmv9RD8gtEXABh/o53OfO9DWYcDhIOoJFvoiOue4Ne+Ux15XOssFsVD8BrO4zSApEHHse9EouALOw/9DM1cL95esfFixePrqqq+hRjjC7uXeNdfNDeLQjCTfv27Xtk06ZNdFiVtenaErkhu8XbOPJAh70gCNd3dnb+YP369YFkDjcmo4StsizfrzssFCMHKpnwuaampid477J4JiFvw3379h1PZbpdEqM6kZIFQbhx9erV/494cqtZRQ4Fzc3N51pA5HhZlv/swqejU4PdGHLa6OjooJCDVpdS6l5ieToSiVxmzcRhDCq723cx4GMwx3tg5iVFNaOXKR1QOYEoHzCtZrpeG6HXerxk5TTea1xJYKQ/DC21kJv3neGmR4GxWDUsMjV4vXkOL3Ukm81OVBTlOMZYLWPsfJ9eVU8wgW0VQfxF0+qmf3vFsxTDo+uYnOMGZRL/PLkuu6WZ0em8i4jfFAShtaqqaoedC3aQPCaTycMZYxeSbAHgSA/aBEIPKoqy8YgjjvgTTwG5YnmloGNZlg/t7u6u1auuurlUUyjAqoqKikfvuuuuncacblnmGWOPNjc3X2jmjzw/Ozo6DhNFUQs6VRRFZIxVIWIlIkYURXmvubnZsXqr01qXLl06UhRFKs9BcWFUUt0rMPt5RFwry/LTXtVzyxYY631IOj9ar4M7BwA2vczedD7uivIBxZ4vfucFGp9fF5xrPWUz1RWujocfqxS09dNACqB1uzsTQEEYEQIS78mVO+ApYJRS0oyhA4MxRvFHjDHWzRjrFARhLyLumj59+n/LeWjysmzu19DQQNoe/XMgIlKgLrk8k7b2liAIrzStbnq5z0FTZ1A3Mx2sKMo4URS1g5h4Y4x9IIri61VVVS+Vmiy2GJnp3pjHqKo6HREpawHdMxFw76qoqNgZiUT+axdw7FaSngC/qakpVhQ/JQyi+Ktp06ZNE0WR5DxRFMVqRVE6EPHtSCTylizL/zSq6/JMExgglQJAZkZ5D8sgAclrTq+15cabNSN7ncnpgfDRdwFwVzDjd2Kwm8HqaKLJXXaWGAsBiee9C/uEEvAtATdAQsQF6XTasS6T78n6aQAetj26Ru3qvpXymJmPGU3B4IgBKpVvLzCwPyRNowqYzo3gMdGVqhn1jreCET8HfJqXvZT5nk+JgGS3B0hLcnBwCAGp1DciHB9KoFACqVRqfHt7u2NNqMrKyiNXrlxJJSEGdcNpDy5ch53yLX25Cr8g5KgNOTDNA0Y8PHgd+ANbMyqEW541m0Xa42VnI2cnTYkJ5NQQetn15fsUzjXwJJBKpUbv69x3ksCET6TT6SWlchiPx5uoeK4DnU5JkniyQ5TKRtnHk5fdBtYp31yumfweglY+XMHI5z0Rj0ak9eHQDAvByHyBVbynnrF+L7l581iaZsQjB5XkZBT40xlHRBlDQCrX6xTSHeASoMzhiNigquoy4zJZluUT1q1bV0p5b9QdGpxW/29JksjJYNA3nP7gwruhU14U9Eq8DlS3+VzzztHAfG/qwMxzPIdwL6iZzXQDDYxK144oHDa/pqj9E7OCUghIQb9JIb3BIIFUKjVl3759TzpUm321pqZmerEOFMuWLTtXluUfO8lBVdX71qxZ01PyfTDIy4lHLkAqBVz8CEcDIuNsNw+0dajzz5XbCG+NI8dQLw0ro/k6k9O6eeYpnc/StCM3U13+Y9HXTPdJulaJEVHGmq5hl1zVzz4P+w4tCaRSqbHt7e2UVNaxCYLwy6amprxcczxSWJxaPLqyvZJqVDkeKTU1NZNSqZRjnSueeQZKHw2QWBk0JN4Fet4PmXPP+ci0YMzPC1teQFF4xPsLetXArATX7p71+PCoywdQ3ifizWeObqFkKXA2BCR+OYc9h44EliQbLoqo+KDHiv43duzY45PJ5Ls8K9dTI1FORMfM5lRLqLm5mTKrD4mm3SGpZbxDspOSWRMSUYRjD5gKY6pHAZl/jBqlCAgC0j8CCHpcD5mRVKb29MvpKHo//b/0/xMNopXrP1Bo0q7S14PEpYlPWpN+xBPM9a4dgVZPjXpoa9LXY+hnZpr7ujvgx2/+BSpYLg6KF4zNz4jXVOfoOCKgjNWhhjQkTodwEdwS0KsHU0CrVx0pylj8oCRJVN/KtjXc1nAEduP39MwOrmU2EPH4dDr9F25GB3hHzcsOyuRlx2OCqxYi0DTrSjhj8rG5A9TQAPRDm6pq0wFtfJXn4jN7TUSg9cv1MZfg1jILGN/xQ4EmY6AwtaCKhrZ2DbgRXn7nNTj76Sao1F2y/QKSX1Od7d4WBBmrO0OT3QB/8UP2gpdAMpkco6oq1UPiad0A8D8AeA8A/kPpmBBxImNsNABQUUaeOkKbJUmq45lssPTB6dsXrmFd8q1BMdzz5Wy+8zcTz7//hxFCBJpPuBI+ftBHgmJhyNHxMvXRggmUdux9Dc76+SqooDihIqTAM48nZUFQQK4IMzUUIf9wyOCXQCKR+CRjjIrulbtRRVeqdzWkKjNrgKR2Zb0ByQlgrGK3v+vP9bIpkkeAJJ1wJZwZApLtBuYBiSAAqUeb9XiNQkAq9zkT0h/UEmCASxuX3iWoQmO51kFJahFxJhW0K9cc/UUXD92+cA3wAJIbh1awsvs8t3VOABghiNB8wlUhINnIlxeMrIAU4SgTYZ2O5+7IE4yIaKgh9de7HM47gCSQTCZXqapaDlAib75TJEkqV42qfpUiHrTtxrWRbtU9ktgKMPm5Q+0XYNWGbCq1ElnSkNbNuhrOmFJqyZB+lWPgk/sBox5Aeuc1OOvpVeAXkAK5OzIkEAJS4HshJDg4JdDQ0DAfETcCwMiAVvCXcePGnZJIJIaUmc4sGzx464L1QlZZXLTA7OKGiJgOYm5f1dSlWozA+lnXwmmTjy2ahaE20C8YGYD0sukOiVcmPJpR7nF630ppWyF0auAVfdhvGEiAyk7s27fvJ4h4agnVY/cKgnBnU1MT1dIa0g2nbl9wt9ip+M/U4KAl8RxcZokSIN09ez6cPIlKrIRNO/w5UhdZJUVODX4BiUcz4gv3zXETAlK4f0MJOEiAAcYT8SQAfEn3oHOq/GoQIPfwtwVBaGhqavr6cJGrBkhCPwbGVosVcPfs61wBqVKsgIiQ7wXZe1AaTuH2j4y3X69Sl1P5ZEWGrCo77gNys66KVPa4pDt15J2f+qmM6mg5r4eAqlMmb9HClvOy2wln/ny15mXn1fJc7B3fIW86xtCea8RQQ/ISffh7KAGg0vZdXV1zFEX5MCIejoidjLE3BUH47bRp08paLHAgi79fAYkOsRoPQKLA2RV/egCkl35I9qAeWeYUtNzFlNuxydvPoKbRVGVomXsDXD7jVEd42Nu9D6Z/N+qpzfDOz9PvlAlHwY/O/TJklWzBntI0JP0OyQuQeDSjHECHgDSQX96Qt1ACQ00C/QJIPcccA6iJuJvsCJBWP7cNNu54Eg4QqOCjf5NW/rFq5xKYX2acNJHUR78Il04/xRGQ9mU7Yfoj9TAm4p71nedI5zHRUYaKk8fMgG+fk3QEJIpDOlOPQ3LbqDzzFQNGGqiHGtJQOyPC9YQS6DMJaE4N2C0X79TAyardwUxf6gRIbk4NBEirnt0GG//9JIwWKj01Eis7vfOaObDxQddT+RiAt2LmZXDJtI+5AtK0R+phrAsgBQVGxBMB0tzRh8L2c5cXrSGVUzMy5B4CEucLEXYLJRBKoNDSQ27fYpdScgEpnsO3ACxYzsvOze1bFES4609bYdOOn8EBgtc9YO8MzlqR2S0w92erNkAaxOoTroQvHHqi45YhDckJkHhlwaOp5BjI5bD76P4Hwfc+5WyyMzI1OLl9887Hqx3ZrRNDt+/wmAklEEqgSAngQVsXrBG7vVMH8R6yfvigL/ZqUYQ1J1ztGBhrANLGHT+D0RyA5Mc8ZwdGhoa0ZvY1cMHBs8sCSLzAYIBRTkNicOx+k+AH593parKj1EFWQOLVjHLQx/+kQ0Dys9vDvqEEQgl4SUADJIEDkLwIFfN7kIBkD0TElZ15Lvf3TocvAcba2dfCZw6e5RuQeI5zfkDqpUaA9OGRE+Hx81eUDZBKBSNNqqGGVMyrEI4JJRBKgM6P/gUkBiPIZHfC1Y7JVd00pMLD3/o35ppFue//3n87P38CDGnW1fDZQ+b4AqTgwKiQEgHS8ftNhkfPu6MIQPLmzA8YuckwBKTwXAklEEqgWAngwdsXlK38hB1TVu2gigJjZ10Lp085znYNTndI3qa5Qu2I99AlHu864Qq4WLtDMkcA97JovkPyPu514xt3wGshRZmpMOeAQ+DhT9zuy8suyEwMxupd3exDL7ti38VwXCiBYS8BnLqtdgN2ZW8upyScTVQMqsVK2Dj7Ojhl8oftAYm87J7bBne/TG7fdk4NZjduO5duf4XqcnWUAO786KXwxekne3rZebl99xziXGBkf9TT31ItJHL73npOo7OXnSV1EO/dES9Q82iXoZddOd+kkHYogaEtAS0OCYvI1MB/D+IuQMrUsGmOc+ogIw6JAGlUDyA5gVC+a7efg1Y7bHXQICqpj8yDy1wCY404pNFecUhcQGR/1JtXQ4B02tjD4YGzE1waUl9rRoYtFMWwQN/QPjLC1YUSKJ8EcMrWG+4Wu1XbXHZBgY4z+zkNiQ+QfmoCJMOMZnXh1k1jPuRlp0UQ1S9/ZJ5rpgYeQOKXn7NmZCyFAOn0sYfDtzwA6eNPrYQK1abwlI1M/AC2p1lSfxShhuRj84VdQwmEEsiTgAZIQlcRyVUDESQ/IK2i1EGCNXUQnznODF9ebBtHeevMqzw1pKkP1QKrqPIi6YLHDECl/HXejTLcfWLckfCQS2AsxSHlAMmbnh8w8jTVmb4LQkDyln3YI5RAKAF7CeBB37lxA3bLZb1DMqa2fmXToThSrIS7Z18LpzqUn6Acba++vxt2d7yjxeKQ1kHmqJzDHKPa3do9DyU71f6HZHrLxdNo/bW+xuc7gKD1yfWnZksTEKaNngzjq0Zpfe0aZU545s0Xc7QcaGqz95jscrzl+BRMfKo6D73HPtHMrSVHW+MTGFQKETh23Axbd3WjhPmZP1sBEWbPc+9z8NR3tK58vSzSEQVZGNE5Zve87R+EL10ogVACoQT8SAAP2nrjOuySb/EziLev+4GW+0anO6QNs67xLNCXlwPb7ry1m4y3Hy3I0pfH3NYDVjoAFpzgvPPz9nMJXO0pP9GXgGTxIdEcQkSUI9XdISDxviRhv1ACoQR6JIAHbb1hDXYpt/qRib8vZ8OeUzjKACSKQzrzoI/4YWHA9OUBrr5gVtOQ3nkNznxqJUQcHpAfMx3XMzZf4elOIUxERZSrxuy5/t4hW9WyL55nOEcogeEoAQ2QwCcg5QRldbHuNQgVCtKuml8uU8IIsQLWnXAVnHXQRwel/AcUIFG275+VDkjFgpG2K0JAGpT7OGQ6lMBAkIBPQOI5qqz2p3xX7N5F95rs1g5CQBooQGTIs/cOyR6QAtWObDSjns+REJAGwnsd8hBKYFBKgJwa1kJ3toRs304X6M5AZNal6A5p/ayr4eNTBpfJbiACklbC3OYOKVAwsmxzqxxCDWlQngMh06EEBoQENKcG6Mr6cGpw8+By0qAcKrtq9ZCohPm1cNpk+9RBA0JKOhMDDYTMsukpYa6Z7HqfUeBgZNKO7OQROjUMpB0b8hJKYHBJQItDwqLjkKwAVAhWbgci/bafWAUb51wHp0yyTx00UMRpd/jyhJ/6jYEy3875Wbud23c5wUjj0y4LhSjIYnVX6GXn5+GV2Le1tfUSQRAmAIAIAAJjTBAEYUttbW17iaTD4aEE+lQCnIDk52jj598ApE1zroOTHQCJ4nZ++sqf4Nk3XwIBewNjnVwq7Gbn7Wv0o1DVsw+ZCTPHHea4mHa5C9Y89yCMFCKuC+ad2wxEdjooub2Pqz4A5n/4PFDUwshXKyD5eWI8N4OaD4vOmKumGAIS/wsQUM9MJvNXAMj7oquurj5w/vz5uwOaIiQTSqBPJKABEnTJtqmD+oIDCox1AyQjl136pSegQqAPwL5pa2deAZdOP6UnMNU667vZdpj+cLS0TA0+loKMwSfHHAEPnrvMPZfdz1aAyIUwvZN7dreJN3JkPQQkW9Fs2bKlpqKiYuR+++339rx58/jSc3DujxCQOAUVdhvwEhgQgORmsjMAacPLP4X90V0bsUrb86C1eTxaJgjGYOXMy1yzfZOGNPW7URjvkly1mPkL1qCbxShTw6ljDoNvn5N0z/btE5A8eXTxqLPd3cMckDLbMvvBblgHAJcBAKWnp39It7RzPyVgkgHgXUEQ2lRVXRuLxXxnuAgBacCfsyGDnBKgAn3rWVf3Ys7+AXdjUKOnDnJyaiBAWvXsNrh7Bz8geR6yDkBk/DUB0upZVA/pJMfyEwRIB303ChMcAKkYHsxsWZO+EiCdNHoabPfIZUepg3g1JE8e/WhGBvPDFJDa2trOUlV1GwCM1u9yinlXSOIESH9FxIXRaPR5HiIhIPFIKewzGCSguX2zkty++ZaZf/+dO+no3yOECGycc62j27dRoO/uHU/CKAcNyfNgdWHR7j6EAKl59tXwuUPmOpTnA3ACpFJ4yQekfEoESLNGTYVHPvnlQEx2nnz61Yx05snLTpSrxg6XTA1f+9rX9u/s7HwMAE4pAYjsdihDxCXRaHSD1xsWApKXhMLfB4sEtMBY1iX7Sh3ktjg/rtEGIG2YfY1jpgY3QPI8VH0CkVlD2jD3Ovj01Fm+AKkUfoy5nYrqESBRCfMfnHenByCtBNGjBpNfPn0902EUGLtu3bqxlZWVzyLiIWV44dVIJDK9trb2f160Q0DyktDA/n3Tpk1HV1VVjSAu9+3b959bbrll78DmuHzc+QYk73pz/o67KiECfgHJ3wyFwvM6YElDunvufDh/6gncgFQqT4bGmMtMXtgIkI4bOQkeP3+Fxx2SOyBx8cnrUWfD57AJjGWAmdYMgcVUp9cTEf8MAGR2e4UxRrn9yD1yFADsj4hTGWOHA8CRZCiwofHDWCx2Ps+rHwISj5QGbp9MJkP7wrhjvCgWiz08cLktL2c4aev8Ndip3lpksYGSuDM0pLtnXwNnOuSyM2tIfp0aI1at7gAAIABJREFUrMx5AZFZQ1o351q44ODZXIDEdch7SMqr3DgB0kf3mwKPnneHs4akJ1d10pC4+CzSVNej4Q0TDamlpWULIi5weKxPC4IQr6ur+73XC5JiKWHi5omfVVX1EgD4GABMozGIeFU0Gv2m13j6PQQkHikNzD6pVEqYMGFCluLHdA6HOSB9Z/5a7FKX9Acg0QPI3SFd51h+olRA4gUh83YlDSk96yr4wqEnegKSm5cd7yvAU26c+swZdQg8/Mnbi7pD8gtGxchN0/KGQfmJVCoVmTBhQqfNnRGJ+dZYLLae99lb++nOETT+k7FY7A0eOiEg8UhpYPbZvHnzZYqiPNDzMayqF990000PDUxuy88VTtw6f73QqS7uD0Cit7dGqICWufMdC/RpXnbPbYOi3L697Yu2EiZAuuuEy2HetI95etmVCkhemlHPRgUGJ4+eDltd4pBe3rsTzvoZmex6l8UFRBqS5DsmFw9IghwZ4pkaWltbFzPG7EDnS7FYbEX5X9v8GUJA6muJBzdfJpP5DwAcalBExHnRaHR7cDMMLko4eev8u6FTXdRXgGQ9IGvECsjMvd4xdZARh7TeIw6p2AM0/3HluCNAWjHzMi0wNq8woKmzEYc0ziUOyW0r6LVsATkRQwYVzhh7BDxwdsKXhsRFPigwIlQTxSEPSJlMhrSjvNr1jLHf19fXn9gfr38ISP0h9WDmzGQyFIvWm4IG4NJYLLY1GOqDj0qfAZLTwThSBySn1EFugGSAEAFI6a2XBoHFipmXu2ZqMABprGh3H+3NjVaG3UcjI/PZYw+Hb7kC0k6tHhJpSNzUAwKjnJI1bADJeohQXr/l9fX1q3w80sC6hoAUmCj7lNC99947oaOjY5dl0hCQ/GhI3Acd56MlQGrx0JBan/sefOO/v4AKm1x2NA1v/nG3fobVymB7yYcvhM9Mdw+MPenxRhgnVDnOb5UVL59Oazpu7KGQOS0GslKYecZcwpwbkAICo7y8ecNDQyoAJEEQLq6rq+sX238ISJyHzQDr1tra+iBj7KIQkHolgJO/c90G6GI3+0nGGeRz1e6QTpwPp0461pEsOTZEBFHLLm38z6wC0GGs5WZBI0ML0/taMlIjgZf+P61v7nc7mipTbZOYGkzSXMSTBh7a/KjP70zTL585QENNn1e0lEYKqDaJVQ0eciXMV4DA89UQEBj1aEaGYIYHIJnddI2VXxiLxR4N8t3gpeUHkPSv8iYAOFPPKkHbqydxPSK+IAjCvYj4YG1t7bu8PBTbL5PJzCFHQQAgF3gyg1aaTFjdiPhbVVWX1dfX/6bYObjHMcC2zW0xVVVTunu+8eVH6Z3ISKEg4j2yLKcXLVr0HjddS8e2trYDVVX9IQDMtH5PM8YyiPgM3RwIgqAwvRkkKI27ntH9sWg0+g4vD62trecxxmoB4HTdGYeeudlUqB0ziPh/ALB1165d30ilUrTuPm04cev164RO5Zb+AqRqGy+7YO6D+lSO/T6ZOdu3KyCVC4h6AImcGrqHdPmJTCZTAPmiKC5auHDhpv7YCHaAFIlERpsBpbW1VWKMkZv6fpwZJegwfk0QhKV1dXWUEimwtnHjxqrKysqvyrJ8PiKO5SRMwaL3RKPRJCLvzSsf5S1bthwiy/KTADCdUzb0QbKbMVZXX1//Xb5ZAFpaWi5FRAkApnDO40g6Eol8qLa29h9uc2/YsGFiRUXF43om+Lw7Tw6eaY/vYow9OWbMmPorrriCG/w4aDt26YlD6i9AGiGIsJ4yNUz5aCnrGPZjzSXMBac7NQsYkdBKAX/bPSMKiihXjRnKqYPsAIkxdl99ff38/tiIdoC0+5jdFakzU/LXvva1KZ2dnT8FgA8VyRvtmsdisdiFRY7PG5bJZK4FgDsB4OAi6f2LMXZOfX39f4scb+XnGwBwhYfl32kqAqY/IeInvLSV1tbW9YyxwHKGMsaOqq+vf8mJsZaWlhbKh1gq8On0mSiKxy5cuPBvQcjcjUafAlJBuWsGUCVSxdir4OyDSHsNW7ES0ABJD4y1BaRya0YG48MDkOggOMLyrF6LRWNTAfn9SYp91tZxdoAUi8Uwk8mQGYwOEco4Xmr7TSwWO7kUIq2trcsYYyuLPPzNU7czxk6rr6//U7H8MMawtbWVchByZcPwmOeVSCRyqluap0wmsxkAyGQWSBNF8ciFCxf+045Ya2trC2MsFshEOhHaT0HSc6JVNkDi+fKmM7JKCAEpiAftqiEFCEbEq6s2PQwAafPmzdcrivJVm+e2MRaL3RzE8/RDw8FkVynLMt0BVVto0d89zxj7lyAIr+ump/EAMBkATgCA4y13Cz3DBUG4ua6ubqMf3oy+mUyG7mW+bDeWMUYpmH6FiC8h4tsEoIyxqYh4DGNsNgCMsxmXZYwd66YlOPGpZ0cg1+qLbfrQrc3fEfFZAHiRzFaISDI8lDF2KgAQPwWNMfZ2RUXFpNraWrprKmitra0EEJ9SVVVFRPqH7oc+CwDWmjrPIOIbxISeaorudXpMxIwxkSoCi6IYraur22mdKJPJ0N3gz+xYBACKefojALyAiLtVVX1PEIRxqqoeSLJGxGmMMUpllbdnEHF7NBqdV8xz9zsGJ31n/lroUpb4HcgDOF40ScojhArYOOdqODM02XmJy/X3nIa0E858amW+U4OxlXmqvXJw4GnaHQaARGKyiR+hv6aDhlL+9ETec4i05C52gETOCYwxcxXZHYi4MloX/bqbFrd58+bZiqJ83VqB1mCymC/ltra2z6iq+n0bzWgfAKyOxWJ3OQnhvvvuG9HR0XEfY+xSmz7Pd3V1nbRkyZIOP0Jsa2urV1XV7r6PDupYNBp92oleJpMhLZGeb08wq6nvT2Kx2Cd4eclkMrT+GnN/tcRMDXbmZD2X4k319fXf8+Jt27Zt1W+99dYXVFW9BgDoHmWCoigjFi1a1OU1NojfceK3rlkHWXZLEMT80qCzsprcvudcC6dPpg+zsBUrAVunhr7UjAzGxaHv1KADEl0Wn+fwvCgHXV0xxfaKef52gGShc380Gr3WjzNAa2vrt+1AgDF2QX19PZm6uNq2bdsqd+/eTRrQRMuAd0ePHj2d97K8tbX1OsbYvTaTro/FYtwf1C0tLUciImk+eQ0Rv79r166LeD3LMpkMmQsL7hkYY7N4TYl2gAQAl8RisQe5hGvptGXLlvGyLFvL1r8RiUSOLsZjksyamzdv/mJdXd13iuGnmDE48VvX3Q1ZpV9KmNN5SQX6MnOvc3X7NhbW66Ldexmvffj3uF3n3Lo1N24tOJT+1ftN3+N2beuinU9TEETX+CaaVlYV3eVbdycvcCUPnk/BFItlfuAFgNQfYEQMDQO3b0PumUzmTQA40OHFoyfw2Ugk8oSTGaeYF9ZujBsgIeJXo9HojX7n0s1adEcxwzJ2VywWs4KLI/lMJkPaBrkam1vH/vvvP+Hqq68mDYG7ZTIZSqljNbNlI5HIBK4DN5ehnZwhrA4Vz0aj0Vl+AJuYzmQy/zaS4ZoW8UEsFtufZ1EOgFR0YGxra2uCMUYu/T0NEc+NRqPk1DIo2oAApNa5851TBwkCfPWFx+ErO34OKPorYV7KE1h21KfhfI/A2HMevw2w0q83ZfFczT5gKmROdQ6M3bH3NaCKsWa372BMqzyBTfq6hhEgfetb3xqzd+9eOpQOcHuqiLhaFMUvlwuYXACJTZgwYcS8efO6i9l1LS0t8xCxII2NHxNOJpMhc5o1nUnRh24mk6G15DlpIGJbNBqNeq2xra3t86qqFpR22L17dwWvZmSeI5PJkHnuR9Z5J0yYUMUj86ABqaWl5XuImOcNyeMe7iW3vvx9UABS03MPwvp//gj2E/KdhXwck75kSkGxXKmDHqqFsRUjuWh73r04UDHWqACDM8ce4ZE6KHhA8s33MAIkemSpVKpywoQJZALSykZ4tHcFQVgYtAnECZBEUbxm4cKF93sx5fR7W1vbQaqqvmr9XVGUA3gCQ1tbW+9ijC2zjP9jLBazdQzg4TOTyZCb9pWWvv+NxWKe8m9paXkSEc8yj0XEW6PR6Dqeue36OJjutsVisS960QwakOwyP0QikZNqa2t/58XLQPm9DwDJGTbIrFYTqXI12UWECKx+bpsGSCMtgFQuIZJWsXLm5fDF6Se7J1d9aAGMraA4Q/fm+1DXyZklR4B0xpjD4dvnJD2Tq5KGVKpmVCzPw8lkZ37qra2tNzHG/Hig/b2iouKSBQsWvOC1f7x+dwKk3bt3i6lUimJlim6ZTOY13QOvh4Y16NaJeEtLSxciUuYFc1sQi8W+UixDX/nKVyZ2d3fbleWY7FauQ3fW+INlXhaNRkW/pjrLc29kjFlzGHLRDRqQNm/efLOiKNaS99+MxWJXFSvvvh6HEx+4dj10U/mJUpt/fSXn1FAJLXOug9MnH2fLAAHSqme3wfp/FWpIpXLsNJ4O89UnXAkXT3PPZXfQQwtgnAsgFXuo20mSAOmU0dNh+7nLPQr0rQBU/T8LqyyK5X24AhLJ7/777x/5/vvv3w0A1/vYm68j4hei0ehvfYzJ6+oESMV4xFl5aG1t/RVj7BTL37se/kZfSyVU+mtyiR5bqrOHgxmwMRaL5d2fmHluaWlp0LMkmP+6PRaL8Zk4HB7Opk2bPikIwhPWn3nMgHaAVEr5iZaWlnGIuMcKuoIgfLmurq7Py6IUs59x0gPXrmXd/VOgL+f2XQkb51wDZ075iCMg3fXsVtjwrx8XmOyKWbDXGC0LN2OwZvY18LlDPAr0OQBS0Ye5zpwTIM0ddQg88skvuWtIT64ALCH7eam8wzDxsnPbR21tbWQ+WqSqqh/v1ecOOOCAM6688krfOdIc3L5/G41GqQJtSS2TyVBqnM+ZiQiCcFxdXd1f3Qi3trYezxijEu7mVpK5zgR07TbxVa4l3+3MWYj4tWg0ekMpAtq4ceNHRFF8zkpjwoQJkXnz5hVmQTZ17EO3b0b58SoqKi648cYbyRFnwDac9MB1a1i30uclzI1Dt4oAafZVcJZDpgbSkMoJSL1ndy8M0KG8Ye718Jmps9wrxpoAqeSDXK+R57RTSEOaud8U+MF5d7prSD/rX0BigqBElKGdOoj3baYvVkEQPg8AtzDGjuEY9wEiNkSjUYrq5252gCQIQqKuro7yppXUMpkM5bGj8uo9rbKy8pgbb7zx726E9dQ1edkCEPE70Wj0spIYynm3FdSjAoC/x2IxRxlnMhnKWJGXPgkRPx+NRh8phZ/W1tYZjLGXrTR2R3eLKXQ3lzqY7EoqYd7W1jZXVVWnOyPSUB9DxFQ0Gn2+lHWXa2yfAJKbAYkAyS11UDkByalIHv39xrk3wPlTT+ACpHKDET18AqSPjpwMj5+/oiwaUiBroActohJRRgzpXHbFvIyZTIai/CmW5nNeCUUFQWh88803Jd77HwcN6bPRaJSCUUtqdoA0YsSIo6+//vqCWB7zRC0tLRRkagUIciOnDAhaw1x6/p6mZyco4NemH5VsMGeqpjGujg2ZTIYyQIyxEH8cETXXc6e5OfikrAYXWJmurq4+ZP78+a+4Cb8cgETz6Yl0Gzwe/E8oWe3u3bsf5t1nJW0kzsFlASTeGwzSTkaIpCFdDWcdZJ9cNWhAyrdm2XNKh/P6OfPhgoNnewISr5ed3fPglZMBSCfsdxA8dt4dLhpSrkBfMSa7UgGpR64hILm+ehs3bhwViURuZYxd7eaZxxi7sb6+3i49UQF9O0BijJ1UX19fsneVXeyPKIof9kq0mclkPgCAku5nOM8wrRulH6qvr7fLnqD9bucu7oe+376VlZWzb7zxRkrT49jKBUg6KC1hjDU7pYEyMbUXEe9gjD0Ui8VcAdSvDIrp33OHVOqBVMzkdF0zIlIJm2ZfAx/vgzskuh/iSVxPsmiefQ18nuMOqS8B6aRRh8LDn7w9UA0piOeeB/IiyhU12SFdfqKovW4ZlEqlIuPHj78TEZc6JD8l77hjY7GYq2lMP2zpPsecJoj++pAgDphMJkNFB79gZr+ysvIjN954o6vJxyGFTRCis6WBiC9Ho1FKJmsH2OQK+37ZJrchXFFRMXfBggVWr768nuW4QzJPoLvtk8MFmSpzxdtcGiL+SFXVRQceeODLXvdfXrSK/b3Hyy6Ig6kYJqpFcvu+Fk6b5OJlp7t9W+OQeObLHZZ+dJFchgfysrtk2sdc3b7Jy84vIPnjRF8ho8pZDE4bPQO2nrtsQAFSgf+EKMgVNUO7HhLPvuPto7sx0x2EnTbxcCwWs1YUtTtwCwCpurr6wPnz51vTyPCy1dMvk8nQHQslAe1pkUhkVm1trWum7b4GJMbY3+rr662grPG8efPmIxRFcSzV4FsoHAN44n+C9rJzYoucbFRVpbtAMkPxZH6nEh+fLiZxLYdo3EHRSB3UX4BUI1aBW6YGv3FIxr2QsWoejcgqIaJBcUiXTj/FMw5pDGdgrH9Y1HFUt7LTHdLHxx4BD5ydCASQgnjets58ISD5fie3bNlSIcsyXdRb70WAJ+bHT8VYv8xlMhm6h8q7I+H8+i/49tKrkf6J7mv0jNdaPVTTHZGQS4adu1ui3wRByzuixVIZfWkI/WS5W9oZjUbTdutzCPAl2hvcaJbCJ1kJo9HoDjd5Bx2H5PVsSW5btmyp02OVKO2Na0kJel7jx48/oy+1pZ7A2CAOKC+BFPyuB8byANLal56AGsE5dZAaYLUOLQ5p5hUaIAkOz6xd7oKpDy2A/SvykvX6FgHvgCww+MTYI90zNVC2b83LzplqUM/Z0bM8BCTeR5rXr7W19XOMsYLqo3pmhy0eB1vZNKTW1tZHGWOfMc8vCMKJdXV1v/fgyW4XrojFYl8qSkAlDCLz6IQJEwrKQkQikcpypXPiYbevAcnMEyW9feuttx5XVfVsD16zsVjMGtzMs7yi+vQvIGnJVd01JFEQYOuLT8FPXum9H8ztdPN+p5SqhY23Xy+1XppXHf0JOHXKsa4a0tU/XwNjhWrHzwxj/t48p+58GrPn1lLY97D9p0LjiZeCohYG3/ckV33yTkdAKjsYEdshIBX1ItKgTCZTEF+DiI9Fo9ECLy7zJANUQyLtgEqCm9uWWCxGVUz7vGUyGaoDNcoCrCfU1dX1eP31NVP9CUjGWimJ7vjx429FRMo24fTF/340Gj2glIwWvLKlO6QN0K3eHNRhxTux0Y/ukFo9sn0TKAkoaulw6NC28tpzgGN+tm+7UnJ0zFN/w+PUiSaNVW0OfoNvLXO4nnmbl2YQfCqqbCviXkCyj0MK6vl6xtyGgOT3Fejpb3doUuG6WCx2mhvRcgKSXcJOHg+ytra2J1VVzcsbBwBPxmKxc4oWUAkD29raXlFVdaqZBCLGo9EoeaL1S7MDJMbYF+vr6+m+p08bmY1VVb1VVdXVdhMLgnBBXV0dd9mRYpnvqYcU1IHllxFy+6Z6SGeE9ZD8ii6vvxMgBflcPcGIOAq97Ip+ji0tLf9FxEMsBJ6NxWJUydWxlROQMpkMZcem4N6eJoriRxcuXGjNwpDHX2tr6yWMMevBui8Wje3fT2Xe7epX7YzFYnkgVfTDK2Jg0PWQimChYIjuAELP1lppuCMajY4st5bUE4cU5MHlJRjzwVYlVsCmOdfAWWHFWC+xuf5OgPTy3tfgLFPqoKCeKRcQGdyFcUhFP8dMJkNJQ621hn4Xi8VO6kdAKqhBVFFRcaxXUlinextBEM6uq6uzK7FdtNx4BmYymTsB4HZr3yDy/fHMb9ennHFIxfJE49ra2k5RVfVXVho8+flKmZfG9hkgmb3fzJfulSLFIV0NZzukDip1gcNlvFVD6hcwImGHgFT0lrNJRkq0Ho3FYnk1bqwTlFlDKkgdxFtjx871m+dOrGgBugzMZDJnAkABEPIE+ZaDH6I5EDUk4mvbtm3inj17XmKM5RVnjEaj5NlYVOQKrwz7DJCcglJDQOJ9VO79rBpSCEjByLXPqOSqmVIyzjz/HES8PRqNruxHDakUQPo1AFgTvL4fiURm1NbWWrNSl1XUums9pTvKc7SgcubRaPTosk7uQDyTyfwHAPKySyDiomg0uqk/+DHPmclkHgCAvLyDQZQz8VoXHviNa9eioi6xxu/QQPq78uIhQJV2h0TZvu1TB3ktIPw9JwGzhgSspBI4Gj1fZjrzQwg1pKK2ZFtb20pVVZdbBstdXV0TlyxZQnnYHFs5NSS7LNk82b6J2ba2tgNVVbXLLv3rWCxmLWlRlNz8DHKqWSWK4skLFy78jR9aQfRtbW39OWPsDDMtxtim+vr6RUHQL4VGJpMhbZK0yp7WF27yeOA3rlkHikrZiEvhv+ixVZEqaJtzLZweOjUULUMDkF5+5zU462croJ8BaUinDrrvvvtGXHfddRTEGljL3Js5GDrgfzYEfxmLxU73mqicgGRXfqKiomLmggULCkouWPlMsZQwoXUCaQEHW38TBOHmuro6PwUNvcTg+ft99903ur29ne7pqqyds9nspMWLF/dpaYa2tra0qqpxCy/P7969e2Z/Jjz92te+tn9nZ2dBGZQ+AaQJ37h2AyrKzf0FSNWRKtg89wY4dfKxOXduUzAOBaWSa7WgJwVWye2bqZCrWaQ/Rt3VmzSEXH/U3MOpT86le3jQjAgCvPzOq3DaT+8AcHFX93prS/4uGeJu31SwDhH/JghCw+uvv/5+qQdHa2vrUYyxf9g9l0gkclptbW3B5bK1bzkByc7tWxTFOQsXLnzGay/R71/96lfHdnV1EQgUpKxBxMz48eNvLjYTAMXQTJw48RhFUVh9fb135V0GuHnL5gsVRbEtOYEj8Ojo9VHXLOZua6aPlY6Ojouj0eg3OWVzeFdXF2VAz2uiKC5auHChb7Nda2vrbRUVFV/fuXPna6Xsy0wmQyZiq7b+fCwWsy9ax7NYzj444ZvX3I2yuqi/AElAAY7YfyKMrhhpCXV1X0F+WKxzX95+RIG3L2+/vqZJ2SP+9O5/ijazlgxGtOBhAEiWCqp0T9IUi8Ye8+PO3NLScgIibgUA24SgiJiORqNJnve4nIBklzqIJ1ODme9MJkOZzf+f01rIsaC2tvbvXhfmlPrmjjvuwClTppyVzWapAqrmfYiI50ej0R/yyIr6tLW1bVBV9WaH/r/T87i9xUOPMh7s2bPnMsYYZaAgJwA1Fot5JjI1aDs4snSJonimXzNiS0vL1xHxGl0mt+zatas1lUp186yD+pAzw+7dux8FgPOsYxDxMK9USLzzuPXrd0CyYy6oC3m/AirJaNmbjiFv2nIAfdDyCQSIjFUPP0Cy22YfUDkEQRB2MMbeRESK3xinqipdnheYr2wIfCUWiy3g3b/lBKRiUwdZec9kMlTa3etuhBwdnmCMvSgIwk5E3F9V1UMYY0cgIh2STvnXzovFYgVlxJ3kp7ukk0Z1pIeM/wUAT1HiVkEQKNPDJMbYJAAgMyppC3YJYnwBUltb29OqqjqZZX8niuJ6RHyYUhxt2LDhkBEjRnxEUZQr9GKHeZqeGZAs66L4tgcEQXg4EonsuOGGG3ruJNva2maqqkrJc28FAMqKbtcCqfTLs58HBCAFfcDyLNzcpyQgspmsHCBkTBO0rAIFI2IyBCS/2y+vvyAIX6qrq6Ovf+5WTkAqNrmqHfOtra2fZowFHu3vV0Mi3kjbam1tbQOAWm5B83X0BUi6VkJFAgvutVw1CcR50WiUYsR6WiaTuQ8AruVjUzMI8WQA3bV79+7JpZgAOfnRuuGE+69Zj6q6uFyHaNAHqJ/F2fUNDHz6UCPSXiCfJTS85BQ4EBkThoDkJXqn39+Dajg2Nt9/kbQyA1JR5SecFqln3n4KAI4oVlDWcYj4mWg0+oNi6LW0tFxK2gPn4cwzBYvFYgVZ290GbmzbOFNQhN8iIncSU7vy6y0tLfci4nU8THL22RaJRK7sywS0mts3U+QlxZ53QR+UnILy3S0QIOpjEDIvMkg5lw2MiOEhnjpIv6Q/CxGbGGOH+d6IlgGISIXubhVF8eliX/xyApKd23ckEjm+trb2L6WsPXNPZg5kgb7wHau8etDfBQANiqL88Kabbtrjdf/kRqulpWWcKIo3qqqa8qupmOj+k3LjIeKv6+rqiDdf7e7Ndx8RUSJ0f3MUz0DG2AX19fV52ua6deuqa2pqzlQUhe4mncxvnuQpeJkxFucpDulJzGcHPPD+a9aoqnJr8YEnPmfso+6BAJDBa34a7rwVlEuzpEmCBKGepQQqGJuHOYzikLZs2XKIoijTGWPHIeIxjDFyUDiCMTbF+rXLGOtGxLcR8V+I+LQCyh8FJlCVU9fKqzyvS2tr6zmMsVGIKDLG6J6loqamZlsQ7uktLS0nIiJd1vd4yZGX2qJFiwrcgnl4zX95ADe1bDoWEecIgkBVaWeQ7ADgAAutfYyxFwRBeF5V1V8wxv5QX1//YikgZMfrli1baN6jFUWZCwCf1vk5iIoSmPpTkN8riPgXxhjlfPuVqqov3nTTTf/2vX7LAPIanDBhwsmIeBZjjMqRfNi0j9oRkVzo/8AE9hgo8EQsFqMy8YWNAbZtbqNihXQ/NJMqD+v/jLfxdqS7sT8zxv4PESkW6w+xWIy8IvulDSlACvysdbGyhkDksF+HESC5vbHa3QDsrma7WNWoUaM6r776aronCBuHBMh9WlGUGkVROl9//fXOvrq/cGLt/vvvH/nWW29ViKLYsWjRoi6OJZTWhWklCbTjzJj7lltu2Vsa0dzojRs3VgmCsF82m1VuWXzLu348Q4OY34vGkACksgARSc7hyq+cYETTBq0ZldVEZ91hISB5vXPh76EEQgk4SEC7Q1K1O6TAj/WyCL1sXPaTWc4QUtAg1EO3bAIrfLxaqinNqSE7Zve87fbmhLLsipBoKIFQAkNBApqXHVOVxQMVkMp+nroAkaajh1GuAAAFoklEQVSt9AFQlwOM+oDtvP1vrAFFUa6o6Q4BaSicDuEaQgn0sQS0OCQmK4v6G5DKDjy9qkjuT/1kjjM/36EERMa6QkDq4zc4nC6UwBCSQL8AUp+BjxWEhjAQadpcz7/6bocWlJMPNaS+E344UyiBISaBQACpzwHG6yF4mOH6yhRXbm2oB2/74QE4aXehhuS1OcPfQwmEEnCSAFK2b1XOOiUaHDyS4wCh3gO8b0/wcpjmBiIYaQpoqCENnncm5DSUwP9v72xC5CiiOF6vu2d6emd2s6tZRSREISiIhxzEi6CeQljEWwYRk0vADYJCggSX5NCQqKBRLwoGJH5c5yAS8eYheBIRP8CLEISAEliJZjfJZKarqqV7ZpadSZvpj+nuqu1/L8uwUFX93q/e1H9f9+tqxQiE70MSnB9XzK67m5Ngu+0iihKijM1ThAYZXvEzFscnVNkVPy84IwjsFAJh2bfg3gktHIqZBZUlQqFQpN2DKcEElCFGcX0j0xCWaCz9ffTCZgKX0BQEQAAEWPhgrBA82Hq83CPqP/4pe9EGwjN6IV+Zxu9kEYorRCP+EKQyIxHnBgG9CUCQMs4fxGgcIAQpY0ChOwhUmEAxl+xSZD+Tc1LmZbio+ChCiMLspIR7RSN/0/gIQarwagLXQSAjgexFDdMWzDivgIpwQjUBSnrpKsu8lClCWcQo6Iuihiwzj74gUG0CpZV9qyg4ZWZCW0IwTeBzjtc0WdF2k1D2nfMEYXgQ2MEEwgdjpcenves+EwJdxCdrdpAWkgoZ0awyQAhS2ihAPxAAgVCQRN/LVZB0wZw1O0jjpwpiNEu/IUhpogB9QAAEwkv+935xeLC5asWOWS7CSdGpIEK5ZYMm8focx27fSYMC7UEABBjt/uzwBzJ4/USFDohRfg/wEhGvtSBIFfo6wVUQmBkB2v3pS+9JX+qxU0MKt8sUn60spORChUlseTKBIKUIUnQBARAICdDix+0zpl07rVvhwbT5y3PRnXZuFYWoMB7Cv1kzmw9g66C4UYJ2IAACIwL06NsvHFu/z/iIETN0xlLYghsTkkr3iQKTC+FDjFk9/wrVm49DkGIGCpqBAAhsEaD5d55/qr44961vGbZuXApZZBNCqaQQbU8Jr/cuHd+z/4DbdvsJ0aE5CIBAxQnQQ+6zjWsLi99Z884TzEy5rULOEFUUnu0uqyZChWVEk/Pe4xtso3fm+hsXz+UcEhgeBEBgBxIg13WN950fj1HLftd06nMq+Ki6AKl4j2hMIAt4BUZUnPj/3Pqeef6rG2sXf1AhjmADCICAXgTClGjhk6P3+Neurtm7Fl6XtfyzJF0EJ3LRVaxiTgUhCmygf3u3uGArN05+eUmvrwCsBQEQUIXAlvrMv7XyiNGo/1xrOs4sREln0ZmcnFCDIETRMRtE0Gbfl13v83NLz728urrqqRLcsAMEQEAvAmPp0IvuK/u/bv153mjaT5Jt6uXJjK1V8b7QnUJZokoSY9STTPY8KW97r92oOxfYiU53xtOA4UAABCpE4I7rc4tnV/Yy0/xJOtYuo9UwSOti8GQzqYMIjTwqPQPteoz1eVd64sODDx9Z6xxqS0Yq55HJYgGtQQAEiicQecOocXZlr21bB3zTOEWWuYcZFPwwFvyOHaO/p/2nHrddeDdieAaMWXw43OWMPmO+kMwXQhpdsSkN9pXP+ZsH9zUvd9odoZStMAYEQEBLAv9fweAeqrda/X02p2c8Qx5hJj3IiC2HXhJF95vc7iFuO4ypPk8iQcL/w5fyV1mn806f/75+8purWkY9jAYBEFCSwNSSuqAs3H3sN+vp9eX7f7l5ZZkJa9DHkON9pTFIaUw++IzbLknbio4ZVgkIf8h9+DkKJ0lD7sPPJG0TjGlbjuc0b1/+a6nBWbuDh16V/DrDKBDQm8B/ciD/bYdiwqcAAAAASUVORK5CYII="/></td>
                            <td style="padding-left: 2rem;"><a class="ui labeled icon button bordered-button-green" href="https://myaccount.google.com/permissions" target="_blank" ><i class="google icon"></i>Google Settings</a></td>
                          </tr>
                        </tbody>
                      </table>
                      </div>
                      <div v-if="gsheetsConnection.email" class="six wide column">
                        <span v-if="gsheetsConnection.spreadsheetId">
                          <a v-on:click="googleSheetsUrl()" href="#">Open SentryKit Spreadsheet</a>
                        </span><br/>
                        ({{ gsheetsConnection.email == 'pending' ? 'pending' : 'Connected as ' + gsheetsConnection.email }})
                        <div v-if="gsheetsConnection.connectionError" class="ui yellow message">
                          <i class="icon exclamation triangle"></i>
                          WARNING: SentryKit <b>cannot access</b> your spreadsheet
                          <div data-tooltip="Click here for more info" style="position: absolute; top: .3em; right: .4em;">
                            <a :href="gsheetsArticleLink" target="_blank">
                              <i class="fitted small circular question inverted icon link"></i>
                            </a>
                          </div>
                        </div>
                        <table class="ui striped very basic table">
                        <tbody>
                          <tr v-for="g in googleSheetsList">
                              <td style="width: 140px;">Added at {{new Date(g.timestamp).toLocaleDateString()}}</td>
                              <td><div v-bind:class="g.clicked ? 'ui primary button' : 'ui button'" v-on:click="deleteAuthorization(g)">{{g.clicked ? 'Confirm revoking authorization' : 'Revoke authorization'}}</div></td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                      <div v-if="!gsheetsConnection.email" class="five wide column">
                        <table class="ui striped very basic table">
                        <tbody>
                            <tr>
                              <td style="width: 100px;"><img  width="100px" src="data:image/png;base64,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"/></td>
                              <!-- <td>Google Sheets</td> -->
                              <td style="padding-left: 2rem;"><a class="ui labeled icon button" v-on:click="googleSheetsAuthorizationUrl()"><i class="google icon"></i>
                            Connect Google Sheets</a></td>
                            </tr>
                          </tbody>
                        </table>
                    </div>
                </div>

                      </div>
                    </div> <!--.Google sheet-->
                  <div class="ui vertical divider">
                    |
                  </div>
                   </div>
                </div>
             </div>
<!--
            <div class="row" v-if="isOwner">
              <div class="two wide column">
                <h4>Zapier Alerts</h4>
              </div>
              <div class="five wide column">

                <a v-if="!hasZapier" class="ui labeled icon button" target="_blank"
                    href="https://zapier.com/apps/sentrykit/integrations"><i class="plug icon"></i>
                    Connect Zapier</a>

              </div>
              <div class="six wide column">
                <span >Already connected? Check out all the </span>
                <a href="https://docs.google.com/document/d/15O8b4mBsAb7ccIrL05jcxJCuo9_kDemcXkgjwMy_VA4/edit?usp=sharing" target="_blank" >triggers</a> you can use in your SentryKit Zaps.
              </div>
            </div>

            <div class="row" v-if="gsheetsConnection.enabled && isOwner">
              <div class="two wide column">
                <h4>Google Sheets</h4>
              </div>
              <div v-if="gsheetsConnection.email" class="five wide column">

                <a class="ui labeled icon button" href="https://myaccount.google.com/permissions" target="_blank" ><i class="google icon"></i>Google Settings</a>

              </div>
              <div v-if="gsheetsConnection.email" class="six wide column">

                <span v-if="gsheetsConnection.spreadsheetId">
                  <a v-on:click="googleSheetsUrl()" href="#">Open SentryKit Spreadsheet</a>
                </span><br/>
                ({{gsheetsConnection.email == 'pending' ? 'pending' : 'Connected as ' + gsheetsConnection.email}})

                <div v-if="gsheetsConnection.connectionError" class="ui yellow message">
                  <i class="icon exclamation triangle"></i>
                  WARNING: SentryKit <b>cannot access</b> your spreadsheet
                  <div data-tooltip="Click here for more info" style="position: absolute; top: .3em; right: .4em;">
                    <a :href="gsheetsArticleLink" target="_blank">
                      <i class="fitted small circular question inverted icon link"></i>
                    </a>
                  </div>
                </div>

              </div>
              <div v-if="!gsheetsConnection.email" class="five wide column">

                <a class="ui labeled icon button" v-on:click="googleSheetsAuthorizationUrl()"><i class="google icon"></i>
                    Connect Google Sheets</a>

              </div>
            </div> -->

            <!-- <div class="row">
              <div class="sixteen wide column">
                <h4 class="ui horizontal divider header">
                  <i class="setting icon"></i>
                  System-wide Settings
                </h4>
              </div>
            </div> -->
            <hr style="width:40%;" class="marginBotton-2" v-if="isOwner">
            <div class="ui column centered grid" style="width: 100%;" v-if="isOwner">
              <h3>Account-level email alert preferences</h3>
              Account-level settings will affect all users in all storefronts
            </div>
            <div class="row">
              <div class="two wide column">
                <h4 v-bind:class="instantAlertDirty ? 'changed-color' : ''">Alert Email Preferences</h4>
              </div>
              <div class="fourteen wide column" style="margin-bottom:-10px;">
                <div class="inline fields">
                  <div class="field">
                    <div class="ui radio checkbox labelCursorFix">
                      <input type="radio" v-bind:value="true" v-model="instantAlert" name="instantAlert" id="radioInstantAlert01">
                      <label for="radioInstantAlert01">Instant Alerts<br/><small>(each alert in its own separate email, <br>sent immediately)</small></label>
                    </div>
                  </div>
                  <div class="field">
                    <div class="ui radio checkbox labelCursorFix">
                      <input type="radio" v-bind:value="false" v-model="instantAlert" name="instantAlert" id="radioInstantAlert02">
                      <label for="radioInstantAlert02">Batched Alerts<br/><small>(group multiple alerts into one message, <br>less emails, slower)</small></label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            <transition name="fadeLeft" mode="out-in">
            <div v-if="instantAlert === true" class="row">
              <div class="two wide column">
                <h4 v-bind:class="alertSubjectDirty ? 'changed-color' : ''"><br>Alert Email Subject</h4>
              </div>
              <div class="fourteen wide column">
                <div class="grouped fields">
                  <div class="field">
                    <div class="ui radio checkbox labelCursorFix">
                      <input type="radio" value="SIMPLE" v-model="alertSubject" id="radioAlertSubject01">
                      <label for="radioAlertSubject01">
                        Simple Subject Line - <i>e.g. New SentryKit Notification (Mon, Jul 31, 2017)</i><br>
                        <small>Great for simplicity: Gmail can group these messages by calendar day</small>
                      </label>
                    </div>
                  </div>
                  <div class="field">
                    <div class="ui radio checkbox labelCursorFix">
                      <input type="radio" value="DETAILED" v-model="alertSubject" id="radioAlertSubject02">
                      <label for="radioAlertSubject02">
                        Detailed Subject Line - <i>e.g. [alert] Buy-box lost - ProductName [ASIN] (Mon, Jul 31, 2017, 10:25 GMT+02:00)</i><br>
                        <small>Great for creating custom email filters for specific products or issue types</small>
                      </label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </transition>
            <transition name="fadeLeft" mode="out-in">
            <div v-if="instantAlert === false" class="row">
              <div class="two wide column">
                <h4 v-bind:class="batchingIntervalHoursDirty ? 'changed-color' : ''">Batching Interval</h4>
              </div>
              <div class="fourteen wide column">
                <div class="inline fields">
                  <div class="field">
                    <div class="ui right labeled input">
                      <input type="number" placeholder="Batching Interval" v-model.number="batchingIntervalHours" min="1" max="24">
                        <div class="ui basic label">hours</div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
            </transition>

            <!-- <div class="row" v-if="authorizations.length > 0 && isOwner">
              <div class="two wide middle aligned column">
                <h4>Connected Apps</h4>
              </div>
              <div class="ten wide column">
                <table class="ui striped very basic table">
                  <tbody>
                    <tr v-for="a in authorizations">
                      <td><img v-bind:src="'data:image/png;base64,' + a.png" width="100px"/></td>
                      <td style="padding-left:35px;">{{a.name}}</td>
                      <td style="padding-left:35px">Added at {{new Date(a.timestamp).toLocaleDateString()}}</td>
                      <td style="padding-left:35px"><div v-bind:class="a.clicked ? 'ui primary button' : 'ui button'" v-on:click="deleteAuthorization(a)">{{a.clicked ? 'Confirm revoking authorization' : 'Revoke authorization'}}</div></td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div> -->

            <hr style="width:40%;" class="marginBotton-2">
            <div class="ui column centered grid" style="width: 100%;" v-if="isOwner">
              <h3>Account Management</h3>
              Change account owner settings, download invoices and update passwords
            </div>
            <div class="row">
              <div class="two wide middle aligned column">
                <h4>Account Password</h4>
              </div>
              <div class="fourteen wide column">
                <button type="button" class="ui labeled icon button" v-on:click="$refs.changePasswordModal.show()"><i class="edit icon"></i>Change password</button>
              </div>
            </div>

            <div class="row">
              <div class="two wide middle aligned column">
                <h4 v-bind:class="nameDirty ? 'changed-color' : ''">Account Owner</h4>
              </div>
              <div class="seven wide column">
                <div class="ui field">
                  <label>First Name</label>
                  <input v-model="firstName" name="firstName" data-lpignore="true" required="true" maxlength="200" class="ui input" />
                </div>
              </div>
              <div class="seven wide column">
                <div class="ui field">
                  <label>Last Name</label>
                  <input v-model="lastName" name="lastName" data-lpignore="true" required="true" maxlength="200" class="ui input" />
                </div>
              </div>
            </div>
<!--
            <div class="row">
              <div class="two wide column">
                <h4 v-bind:class="sellersDirty ? 'changed-color' : ''">Seller Accounts</h4>
              </div>
              <div v-if="!isEmptyObject(sellers)" class="twelve wide column">
                <table class="ui very basic compact table">
                  <thead>
                    <tr>
                      <th class="three wide">Seller ID</th>
                      <th class="one wide">Region</th>
                      <th class="four wide">Account nick name</th>
                      <th class="three wide">Auth Token</th>
                      <th v-if="showAdvertisementApiSettings" class="two wide" data-tooltip="Advertisement spending data is used by the Profit Dashboard">Connect to Ad API</th>
                      <th v-if="anyAccountMayNeedReAuthorization" class="one wide"></th>
                      <th class="one wide">Re-Authorize</th>
                      <th class="one wide" v-if="isOwner">Delete</th>
                    </tr>
                  </thead>
                  <tbody>
                    <seller-account v-for="s in filteredSellers" :key="s.sellerId.value" :seller="s" :showAdvertisementApiSettings="showAdvertisementApiSettings" :anyAccountMayNeedReAuthorization="anyAccountMayNeedReAuthorization" :isOwner="isOwner"
                      v-on:account-changed="onSellerAccountChanged" v-on:sellerAccountDeleted="sellerAccountDeleted"
                      ref="sellerAccounts" />
                  </tbody>
                </table>
              </div>
              <div v-else class="twelve wide column">
                <i>No seller accounts found</i>
              </div>
            </div>
            <div class="row">
              <div class="two wide middle aligned column">
              </div>
              <div class="fourteen wide column">
                <button style="margin-top:-10px" type="button" class="ui labeled icon button" v-if="isOwner" v-on:click="showAddSellerAccountModal"><i class="add circle icon"></i>Add seller account</button>
              </div>
            </div> -->
            <div v-if="$root.paymentStatus !== 0" class="row" v-show="isOwner">
              <div class="two wide column"><h4>Payment</h4></div>
              <div class="fourteen wide column">
                <p style="white-space:pre-wrap">{{paymentStatusMessage}}</p>
                <div id="paymentMethods" :class="'ui labeled icon button'">
                  <i class="credit card alternative icon"></i>{{hasPaymentDetails ? 'Change' : 'Add'}} payment method
                </div>
                <div class="ui fluid popup">
                  <div class="ui two column center aligned very relaxed grid">
                    <div class="column">
                      <h4 class="ui header">Card</h4>
                      <button id="stripeButton"
                              type="button"
                              class="ui labeled icon button"
                              :class="{
                                loading: stripeButtonClicked || updatePaymentInProgress,
                                disabled: updatePaymentInProgress
                              }"
                              style="margin: 0.5em 0 1.7em"
                              @click="openStripeWidget">
                        <i class="credit card alternative icon"></i>{{hasPaymentDetails ? 'Change' : 'Set'}}
                      </button>
                      <div class="ui top right attached teal label">Recommended</div>
                      <div v-if="paymentMethod && paymentMethod.method === 'card'"
                           class="ui bottom attached small blue label">
                        Selected
                      </div>
                    </div>
                    <div class="column">
                      <h4 class="ui header">ACH transfer</h4>
                      <div class="ui labeled icon button"
                           style="margin: 0.5em 0 1.7em"
                           :class="{
                             loading: updatePaymentInProgress,
                             disabled: updatePaymentInProgress || paymentMethod && paymentMethod.method === 'ach'
                           }"
                           @click="createAchSource">
                        <i class="university icon"></i>Set
                      </div>
                      <div class="ui top right attached label">Beta</div>
                      <div v-if="paymentMethod && paymentMethod.method === 'ach'"
                           class="ui bottom attached small blue label"
                           style="cursor: pointer"
                           @click="viewAchDetails">
                        Selected (Click for details)
                      </div>
                    </div>
                  </div>
                  <div class="ui vertical divider">
                    OR
                  </div>
                </div>
                <button type="button" class="ui labeled icon button" style="margin-left:60px" v-on:click="showInvoiceModal"><i class="list icon"></i>Invoices</button>
                <button v-if="!subscriptionCanceled" type="button" style="opacity:0.7;margin-right:10%;float:right;" class="ui labeled icon button" v-on:click="openCancelConfirm"><i class="remove icon"></i>Cancel my subscription</button>
                <button v-else type="button" v-bind:class="'ui labeled icon '+(hasPaymentDetails ? '' : 'disabled ')+'button'" v-on:click="openResumeConfirm"><i class="play icon"></i>Re-activate subscription</button>
                <div class="ui yellow segment" style="width:90%;clear:both;">
                  <small>
                  Our payment processor is <a href="https://stripe.com/about" target="_blank">Stripe</a>. All billing info, credit card numbers etc. go directly to them through their secure overlay.
                  <br/>We never see or store anything - simply get a note from them that everything is good.
                </small>
                </div>
              </div>
            </div>
          </div>
        </form>

        <change-password-modal ref="changePasswordModal" />

        <div id="addSellerAccountModal" class="ui modal add-storefront-modal">
          <i class="close icon"></i>
          <div class="header">Connect Amazon storefront</div>
          <div class="ui content">
            <p class="add-storefront-modal-desc">Approve SentryKit on Amazon.</p>
            <add-seller-account v-on:sellerAccountAdded="onSellerAccountAdded" :show-nickname="true" />
          </div>
        </div>

        <div id="successModal" class="ui modal">
          <i class="close icon"></i>
          <div class="header" style="color: green;">Success</div>
          <div class="ui content">
            <div class="description">{{ successMessage }}</div>
          </div>
          <div class="actions">
            <div class="ui black deny button">Close</div>
          </div>
        </div>

        <div id="deleteSellerAccountModal" class="ui basic modal">
          <div class="ui icon header"><i class="trash icon"></i>Would you like to remove you seller account?</div>
          <div class="ui center aligned container"><div class="content">
            <h4>Your data for this account will be permanently deleted, however you can re-add this account any time in the future.</h4>
            <p>The removal process may take a few minutes.</p>
          </div></div>
          <div class="actions">
            <div class="ui red basic cancel inverted button"><i class="remove icon"></i>No</div>
            <div class="ui green ok inverted button"><i class="checkmark icon"></i>Yes</div>
          </div>
        </div>

        <div id="deUserConfirmModal" class="ui basic modal">
          <div class="ui icon header"><i class="trash icon"></i>Would you like to deactivate selected users?</div>
          <div class="ui center aligned container"><div class="content">
            <h4>Your data for this account will be permanently deleted, however you can re-add this user any time in the future.</h4>
          </div></div>
          <div class="actions">
            <div class="ui red basic cancel inverted button"><i class="remove icon"></i>No</div>
            <div class="ui green ok inverted button"><i class="checkmark icon"></i>Yes</div>
          </div>
        </div>

        <div id="cancelSubscriptionModal" class="ui basic modal">
          <!-- <i class="close icon"></i>
          <div class="header">Cancel Subscription</div> -->
          <div class="ui center aligned container">
            <div class="content">
              <h4>We appreciate you as a subscriber, we don't want to see you go.</h4>
            <p>Here's 25% off for your next 6 months.<br/>If you cancel, your subscription will stop auto renewing today and you will not be eligible for any discount offers.<br><br></p>
            </div>
          </div>

          <div class="actions">
            <div class="ui left-aligned-container">
              <button class="ui basic cancel inverted button" v-on:click="cancelSubscriptionConfirm"><i class="remove icon"></i>Continue to Cancel</button>
            </div>
            <button class="ui button primary submit" v-on:click="applyCouponConfirm">Get 25% Off</button>
            <button class="ui basic cancel inverted button">Back to Account Settings</button>
          </div>
        </div>

        <div id="cancelSubscriptionNewPricingModal" class="ui basic modal">
          <div class="ui center aligned container">
            <div class="content">
              <p>We appreciate you as a subscriber and we don't want to see you go.</p>
              <p>We'd like to offer you our new pricing, featuring daily ASIN tracking!<br>
                <strong>{{ $root.newPricingMessage }}</strong></p>
              <p>If you still choose to cancel now, your subscription will stop auto renewing<br>today and you will not be eligible for any future discount offers.</p>
            </div>
          </div>

          <div class="actions">
            <div class="ui left-aligned-container">
              <button class="ui basic cancel inverted button" v-on:click="cancelSubscriptionConfirm"><i class="remove icon"></i>Continue to Cancel</button>
            </div>
            <button class="ui button primary submit" v-on:click="redeemNewPricing">Redeem New Pricing</button>
            <button class="ui basic cancel inverted button">Back to Account Settings</button>
          </div>
        </div>

        <div id="cancelSubscription" class="ui basic modal">
          <!-- <div class="ui icon yellow header">Would you really like to cancel your subscription?</div> -->
          <div class="ui icon yellow header">It looks like you are attempting to cancel your subscription</div>
          <!-- <div class="ui center aligned container">
            <div class="content">
            <h4 style="color:grey;">You may of course rejoin later, but unfortunately you won't be eligible for any promotions,<br/>only the full price listed on our website and without a trial period. </h4>
            </div>
          </div> -->
          <div class="actions">
            <div class="ui left-aligned-container">
<!--                <div v-bind:class="'ui red basic ok inverted ' + (cancelInProgress ? 'loading ' : '') + 'button'"><i class="checkmark icon"></i>Continue to Cancel</div>-->
                <div :class="'ui red basic ok inverted ' + (cancelInProgress ? 'loading ' : '') + 'button'" v-on:click="newPricingOrDiscount" ><i class="checkmark icon"></i>Continue to Cancel</div>
            </div>
              <div class="ui basic cancel inverted button"><i class="remove icon"></i>Back to Account Settings</div>
            </div>
        </div>


        <div id="resumeSubscription" class="ui basic modal">
          <div class="ui icon header"><i class="play icon"></i>Would you like to resume your subscription?</div>
          <div class="ui center aligned container"><div class="content">
            <h4>You may cancel your subscription any time in the future.</h4>
          </div></div>
          <div class="actions">
            <div class="ui red basic cancel inverted button"><i class="remove icon"></i>No</div>
            <div v-bind:class="'ui green ok inverted '+(resumeInProgress ? 'loading ': '')+'button'"><i class="checkmark icon"></i>Yes</div>
          </div>
        </div>

        <div id="invoicesModal" class="ui basic modal">
          <div class="ui button" :class="editBillingNameState ? ['disabled'] : []" style="float:right;" v-on:click="editBillingNameState=true"><i class="pencil alternate icon"></i>Update name on Invoice</div>
          <br/><br/><br/><br/><br/>
          <div v-if="!editBillingNameState && invoices.length > 0" class="ui icon header">Invoices</div>
          <center>
            <div v-if="!editBillingNameState" class="scrolling content" style="min-height:200px">
              <table v-if="invoices.length > 0" class="ui striped table" style="width:600px">
                <thead><tr>
                  <th>Invoice start date</th>
                  <th>Invoice end date</th>
                  <th>Amount</th>
                  <th></th>
                </tr></thead>
                <tbody>
                  <tr v-for="i in invoices">
                    <td>{{i.from}}</td>
                    <td>{{i.to}}</td>
                    <td>{{i.totalAmount/100.0}} USD</td>
                    <td><a v-bind:href="i.url" target="_blank">View Invoice</a></td>
                  </tr>
                </tbody>
              </table>
              <div v-else style="margin-top:150px;margin-bottom:150px">You have no invoices yet</div>
            </div>
          </center>
          <div v-if="!editBillingNameState" class="actions">
            <div class="ui inverted cancel button"><i class="close icon"></i>Close</div>
          </div>
          <div v-else class="scrolling content ui form">
            <div class="field">
              <label style="color:#ffffff;">Name on Invoice</label>
              <input type="text" v-model="billingName" autofocus="true"/>
            </div>
            <div class="ui primary button" :class="editBillingNameState == 'inprogress' ? ['loading'] : []" v-on:click="saveBillingName">Save</div>
            <div class="ui button" :class="editBillingNameState == 'inprogress' ? ['disabled'] : []" v-on:click="editBillingNameState=false">Cancel</div>
          </div>
        </div>

        <div id="paymentMethodModal" class="ui tiny modal">
          <i class="close icon"></i>
          <template v-if="paymentMethod">
            <div class="header">
              ACH Details
            </div>
            <div v-if="paymentMethod.details" class="content" style="padding-bottom: 3.5em">
              <div v-if="packageCost">
                <h3 class="ui horizontal divider header">
                  <i class="dollar sign icon"></i>
                  Current Balance
                </h3>
                <h4 class="ui center aligned header"
                    :class="{ warning: !hasEnoughACHFunds }">
                  Your current balance is ${{ paymentMethod.details.balance/100.0 }} USD
                </h4>
                <div id="achProgressBalance"
                     class="ui indicating progress"
                     :data-value="paymentMethod.details.balance"
                     :data-total="packageCost">
                  <div class="bar">
                    <div class="progress"></div>
                  </div>
                  <div v-if="hasEnoughACHFunds" class="label">
                    You have enough funds for the next charge of your current subscription fee (${{packageCost/100.0}})
                  </div>
                  <div v-else class="label">
                    You don't have enough funds for the next charge of your current subscription fee (${{packageCost/100.0}}). Please add funds using info below before billing date.
                  </div>
                </div>
                <br/>
              </div>
              <h3 class="ui horizontal divider header">
                <i class="university icon"></i>
                Bank Info
              </h3>
              <div class="ui two column relaxed grid">
                <div v-for="(value, name) in paymentMethod.details" class="row">
                  <div class="right aligned column" style="text-transform: capitalize">
                    <h4>{{ name.replaceAll('_', ' ') }}</h4>
                  </div>
                  <div class="left aligned column">{{ name === 'balance' ? value/100.0 : value }}</div>
                </div>
              </div>
              <div class="ui bottom attached label" style="text-align: center;">
                This is a beta feature, if you found some inconsistency please <a style="color: black;" @click.prevent="$root.showIntercom">contact us</a>
              </div>
            </div>
          </template>
        </div>

        <!-- Payment Element Modal for Stripe Payment Method Updates -->
        <div id="paymentElementModal" class="ui small modal">
          <i class="close icon" @click="paymentElement && paymentElement.unmount()"></i>
          <div class="header">
            Update Payment Method
          </div>
          <div class="content">
            <div v-if="error" class="ui error message">{{error}}</div>
            <div id="payment-element">
              <!-- Stripe Payment Element will be mounted here -->
            </div>
            <div id="payment-element-errors" role="alert"></div>
          </div>
          <div class="actions">
            <div class="ui button" @click="paymentElement && paymentElement.unmount(); $('#paymentElementModal').modal('hide')">Cancel</div>
            <button class="ui primary button"
                    :class="{ loading: updatePaymentInProgress }"
                    :disabled="updatePaymentInProgress"
                    @click="confirmPaymentMethod">
              Update Payment Method
            </button>
          </div>
        </div>

        <div id="addUserModal" class="ui modal">
            <i class="close icon"></i>
            <div class="header">Add User</div>
            <div class="ui content">
              <div class="ui">
                  <form class="ui form" action="javascript:void(0)">
                    <div class="field">
                      <label>Name *</label>
                      <div class="two fields">
                        <div class="field focus">
                          <input type="text" v-model="user.firstName" name="firstName" :placeholder="$t('First Name')" required="true" autofocus="true" >
                        </div>
                        <div class="field">
                          <input type="text" v-model="user.lastName" name="lastName" :placeholder="$t('Last Name')" required="true" autofocus="true" >
                        </div>
                      </div>
                    </div>
                    <div class="field">
                      <label>{{ 'Email *' | translate }}</label>
                      <input id="email1" type="email" name="email1" v-model="user.email" :placeholder="$t('Email')" required="true"/>
                    </div>

                    <div class="actions">
                      <button v-bind:class="addEmailAddressInProgress ? 'ui right floated loading button' : 'ui right floated primary button'"  v-on:click="convertIntoUser()">Save</button>
                    </div>
                    <br><br>
                  </form>
              </div>
              </div>
            </div>
        </div> <!--.addUserModal-->
        <div id="deactivateUserModal" class="ui modal">
              <i class="close icon"></i>
              <div class="header">Deactivate Users</div>
              <div class="ui content">
                  <div class="ui form">
                    <div class="field">
                      <label>User</label>

                    </div>
                  </div>
                  <template>
                    <div>
                      <div class="ui multiple selection dropdown" ref="dropdown">
                        <input type="hidden" name="selectedOptions">
                        <i class="dropdown icon"></i>
                        <div class="default text">Select Users</div>
                        <div class="menu">
                          <div class="item" data-value="-1">All</div>
                          <div
                            v-for="u in tenantUsersForDeactivateModal"
                            :key="'deactivate-user-' + u.id"
                            class="item"
                            :data-value="u.email"
                          >
                            {{ formatTenantUserDropdownLabel(u) }}
                          </div>
                        </div>
                      </div>
                    </div>
                  </template>
              </div>
              <div class="actions">
                <button class="ui right floated red button" v-on:click="deactiveUsers">Deactivate</button>
                <br><br>
              </div>
        </div> <!-- .deactivateUserModal-->
      <div v-if="paymentDetailsSaved" class="ui success message">
        <i class="close icon" v-on:click="paymentDetailsSaved=false"></i>
        <div class="header">Payment details have been saved successfully</div>
      </div>
      <div v-else-if="error" class="ui error message">
        <i class="close icon" v-on:click="error=''"></i>
        <div class="header">Error</div>
        <p>{{error}}</p>
      </div>
      <button v-bind:class="dirty ? 'ui primary button' : 'ui primary disabled button'" v-on:click="save">Save</button>
      <button class="ui button" v-on:click="$router.push($root.defaultPath)">Cancel</button>
      <div v-if="dirty" class="ui basic left pointing label">
        Save for the changes to take effect
      </div>
    </div>
    <br><br><br>
  </div>
</template>

<script>
import { stripePublishableKey } from './utils/stripePublishableKey.js'
import ChangePasswordModal from './components/settings/ChangePasswordModal'
import AddSellerAccount from './components/settings/AddSellerAccount'
import SellerAccount from './components/settings/SellerAccount'
import DailyDigestTiming from './components/settings/DailyDigestTiming'
import PasswordInputPair from './components/PasswordInputPair'
import $ from 'jquery'
import md5 from 'blueimp-md5'

export default {
  components: {
    AddSellerAccount,
    ChangePasswordModal,
    SellerAccount,
    DailyDigestTiming,
    PasswordInputPair
  },
  data: function () {
    return {
      emailAddresses: [],
      sellers: [],
      filteredSellers: [],
      message: '',
      successMessage: '',
      teamsMessage: '',
      alertMessage: '',
      error: '',
      sellersDirty: false,
      addEmailAddressInProgress: false,
      emailDirty: false,
      emailsValid: true,
      instantAlert: null,
      initialInstantAlert: null,
      batchingIntervalHours: null,
      initialBatchingIntervalHours: null,
      alertSubject: 'DETAILED',
      initialAlertSubject: 'DETAILED',
      paymentStatusMessage: '',
      paymentMethod: null,
      stripeButtonClicked: false,
      subscriptionCanceled: false,
      hasPaymentDetails: true,
      cancelInProgress: false,
      redeemedNewPricing: false,
      resumeInProgress: false,
      updatePaymentInProgress: false,
      paymentDetailsSaved: false,
      stripeInstance: null,
      paymentElement: null,
      elementsGroup: null,
      setupIntentClientSecret: null,
      isOwner: false,
      watchDogTypesToDisplayName: {'BAD_REVIEW': 'Recent Review', 'KEYWORD': 'Keyword Tracking', 'PRICE': 'Price Change Alert', 'INVENTORY': 'FBA Stock', 'FBM_INVENTORY': 'FBM Stock'},
      watchDogTypes: ['BAD_REVIEW', 'TOP_REVIEW', 'PRODUCT_DETAILS_RECENT_CHANGE', 'PRODUCT_CATEGORY_RECENT_CHANGE', 'LOST_BUYBOX', 'NO_ADD_TO_CART', 'PRICE', 'KEYWORD'],
      packageDetails: null,
      addonCount: 0,
      autoSelectingAddon: null,
      invoices: [],
      billingName: '',
      editBillingNameState: false,
      alertSettingsAni: false,
      showAdvertisementApiSettings: false,
      authorizations: [],
      googleSheetAuth: null,
      zapierAuth: null,
      hasZapier: false,
      zapierList: [],
      googleSheetsList: [],
      gsheetsConnection: {enabled: false, email: null, spreadsheetId: null, connectionError: false},
      gsheetsArticleLink: 'https://help.sentrykit.com/en/articles/5279959-how-to-reconnect-google-sheet-in-sentrykit',
      firstName: '',
      firstNameOrig: '',
      lastName: '',
      lastNameOrig: '',
      anyAccountMayNeedReAuthorization: false,
      user: {
        firstName: '',
        lastName: '',
        email: ''
      },
      showAllUsers: false,
      selectedOptions: [],
      selectedTeamStorefronts: [],
      storefrontUsers: null,
      alertUser: null,
      selectedAssignedUser: [],
      assignedUserList: [],
      selectedAlertUser: [],
      alertUserList: [],
      selectedAlertUserEmail: null,
      manageAlertSettings: false,
      disableAllAlerts: false,
      enableAllAlerts: false,
      suppressedWatchdogs: [],
      showSuppressedMsg: {},
      tenantUsers: [],
      tenantUsersLoading: false,
      tenantUsersError: ''
    }
  },
  methods: {
    loadTenantUsers: function () {
      this.tenantUsersLoading = true
      this.tenantUsersError = ''
      this.$http.get('/api/identity/users').then((response) => {
        const body = response.body || {}
        const list = Array.isArray(body.users) ? body.users : []
        this.tenantUsers = list.map(function (u) {
          const firstName = u.first_name != null ? u.first_name : u.firstName
          const lastName = u.last_name != null ? u.last_name : u.lastName
          let fullName = u.full_name != null ? u.full_name : u.fullName
          if (!fullName && (firstName || lastName)) {
            fullName = [firstName, lastName].filter(Boolean).join(' ')
          }
          return {
            id: u.id,
            email: u.email,
            firstName: firstName,
            lastName: lastName,
            fullName: fullName || '',
            isOwner: !!(u.is_owner != null ? u.is_owner : u.isOwner)
          }
        })
        this.tenantUsersLoading = false
        var self = this
        this.$nextTick(function () {
          self.refreshSemanticDropdowns()
        })
      }, (response) => {
        this.tenantUsersLoading = false
        const body = response.body || {}
        this.tenantUsersError = body.message || response.statusText || 'Failed to load users'
      })
    },
    fetchSuppressedWatchdogs () {
      this.$http.get('/api/operations/tenant-features/suppressed-alerts')
        .then((response) => {
          console.log('Suppressed watchdogs API response:', response.body)
          this.suppressedWatchdogs = response.body.map(x => x.toUpperCase())
        })
    },
    isSuppressed (wdt) {
      console.log('isSuppressed', wdt, this.suppressedWatchdogs)
      if (!Array.isArray(this.suppressedWatchdogs) || this.suppressedWatchdogs.length === 0) return false
      return this.suppressedWatchdogs.includes(wdt.toUpperCase())
    },
    selectAssignedUser: function (option) {
      const hasAddr = option && option.emailAddressId != null && option.emailAddressId !== ''
      if (hasAddr && option.email) {
        this.selectedAssignedUser.push(option.email)
        this.assignedUserList = this.emailAddresses.filter(ea => this.selectedAssignedUser.includes(ea.email))
      } else {
        this.selectedAssignedUser.push('-1')
        this.assignedUserList = this.emailAddresses
      }
    },
    formatTenantUserDropdownLabel: function (u) {
      if (!u) return ''
      const em = u.email || ''
      if (u.fullName && String(u.fullName).trim()) {
        return u.fullName + ' — ' + em
      }
      return em
    },
    onAlertUserChange: function () {
      console.log(this.alertUser)
      if (this.alertUser && this.alertUser !== '-1') {
        this.alertUserList = this.emailAddresses.filter(ea => ea.email === this.alertUser)
      } else {
        this.alertUserList = []
      }
    },
    deactiveUsers: function () {
      const self = this
      if (!this.selectedOptions || !this.selectedOptions.length) {
        this.error = 'Please select at least one user to deactivate.'
        setTimeout(function () { self.error = '' }, 5000)
        return
      }
      const el = $('#deUserConfirmModal')
      el.modal({
        onApprove: function () {
          self.deleteUser()
          return true
        }
      })
      el.modal('show')
    },
    deleteUser: function () {
      const self = this
      const selected = (this.selectedOptions || []).slice()
      if (!selected.length) {
        this.hideDeactivateUserModal()
        return
      }
      this.emailAddresses.filter(ea => selected.indexOf(ea.email) !== -1).forEach(ea => {
        ea.isDeleted = true
      })
      this.hideDeactivateUserModal()
      const req = this.save()
      if (req && typeof req.then === 'function') {
        req.then(function () {
          self.selectedOptions = []
          self.$nextTick(function () {
            try {
              if (self.$refs.dropdown && window.$(self.$refs.dropdown).length) {
                window.$(self.$refs.dropdown).dropdown('clear')
              }
            } catch (e) {}
          })
        })
      }
    },
    sellerIdInList: function (list, storefrontId) {
      if (!list || !list.length || storefrontId === null || storefrontId === undefined || storefrontId === '') return false
      var sid = String(storefrontId)
      for (var i = 0; i < list.length; i++) {
        if (String(list[i]) === sid) return true
      }
      return false
    },
    /** Refresh team table: users (non-primary) with access to any of the selected storefronts. */
    syncAssignedUserListFromTeamStorefronts: function () {
      var sids = this.selectedTeamStorefronts || []
      if (!sids.length) {
        this.assignedUserList = []
        return
      }
      var self = this
      this.assignedUserList = this.emailAddresses.filter(function (ea) {
        if (ea.isDeleted || ea.isPrimary || !ea.isUser) return false
        return sids.some(function (sf) {
          return self.sellerIdInList(ea.allowedSellerAccounts, sf)
        })
      })
    },
    saveStorefrontTeams: function () {
      var self = this
      var sids = (this.selectedTeamStorefronts || []).filter(function (id) {
        return id != null && id !== ''
      })
      if (!sids.length) {
        this.error = 'Select at least one storefront.'
        setTimeout(function () { self.error = '' }, 5000)
        return
      }
      if (this.isEmptyObject(this.assignedUserList)) {
        this.error = 'Select at least one user.'
        setTimeout(function () { self.error = '' }, 5000)
        return
      }
      this.emailAddresses.filter(function (ea) {
        return self.assignedUserList.some(function (filterEl) {
          return filterEl.email === ea.email
        })
      }).forEach(function (ea) {
        sids.forEach(function (sid) {
          if (!self.sellerIdInList(ea.allowedSellerAccounts, sid)) {
            ea.allowedSellerAccounts.push(sid)
          }
        })
      })
      this.save('teams')
    },
    deleteAssignedUser: function (ea) {
      var self = this
      var sids = (this.selectedTeamStorefronts || []).filter(function (id) {
        return id != null && id !== ''
      })
      if (!sids.length) {
        this.error = 'Select storefront(s) above before removing a user from those storefronts.'
        setTimeout(function () { self.error = '' }, 5000)
        return
      }
      ea.allowedSellerAccounts = ea.allowedSellerAccounts.filter(function (d) {
        return !sids.some(function (sid) {
          return String(sid) === String(d)
        })
      })
      this.assignedUserList = this.assignedUserList.filter(function (e) {
        return e.email !== ea.email
      })
      this.updateEmailDirty()
    },
    onDisableAllAlertChange: function () {
      for (let i = 0; i < this.watchDogTypes.length; ++i) {
        const wdt = this.watchDogTypes[i]
        this.enableAllAlerts = !this.disableAllAlerts
        if (this.disableAllAlerts) {
          this.emailAddresses.filter(ea => ea.email === this.alertUserList[0].email)[0].alertsSettings[wdt].GREEN = false
          this.emailAddresses.filter(ea => ea.email === this.alertUserList[0].email)[0].alertsSettings[wdt].RED = false
          this.emailAddresses.filter(ea => ea.email === this.alertUserList[0].email)[0].alertsSettings[wdt].AMBER = false
        } else {
          const selectedEmail = this.emailAddresses.filter(ea => ea.email === this.alertUserList[0].email)[0]
          this.emailAddresses.filter(ea => ea.email === this.alertUserList[0].email)[0].alertsSettings[wdt].GREEN = selectedEmail.alertsSettings[wdt].orig.GREEN
          this.emailAddresses.filter(ea => ea.email === this.alertUserList[0].email)[0].alertsSettings[wdt].RED = selectedEmail.alertsSettings[wdt].orig.RED
          this.emailAddresses.filter(ea => ea.email === this.alertUserList[0].email)[0].alertsSettings[wdt].AMBER = selectedEmail.alertsSettings[wdt].orig.AMBER
        }
      }
    },
    onEnableAllAlertChange: function () {
      for (let i = 0; i < this.watchDogTypes.length; ++i) {
        const wdt = this.watchDogTypes[i]
        this.disableAllAlerts = !this.enableAllAlerts
        if (this.enableAllAlerts) {
          this.emailAddresses.filter(ea => ea.email === this.alertUserList[0].email)[0].alertsSettings[wdt].GREEN = true
          this.emailAddresses.filter(ea => ea.email === this.alertUserList[0].email)[0].alertsSettings[wdt].RED = true
          this.emailAddresses.filter(ea => ea.email === this.alertUserList[0].email)[0].alertsSettings[wdt].AMBER = true
        } else {
          const selectedEmail = this.emailAddresses.filter(ea => ea.email === this.alertUserList[0].email)[0]
          this.emailAddresses.filter(ea => ea.email === this.alertUserList[0].email)[0].alertsSettings[wdt].GREEN = selectedEmail.alertsSettings[wdt].orig.GREEN
          this.emailAddresses.filter(ea => ea.email === this.alertUserList[0].email)[0].alertsSettings[wdt].RED = selectedEmail.alertsSettings[wdt].orig.RED
          this.emailAddresses.filter(ea => ea.email === this.alertUserList[0].email)[0].alertsSettings[wdt].AMBER = selectedEmail.alertsSettings[wdt].orig.AMBER
        }
      }
    },
    convertIntoUser: function () {
      if ($(this.$el).find('form.ui.form').form('is valid')) {
        const timezoneOffsetMins = 0 - new Date().getTimezoneOffset()
        const body = {
          email: this.user.email,
          firstName: this.user.firstName,
          lastName: this.user.lastName,
          timezoneOffsetMins: timezoneOffsetMins,
        }
        this.addEmailAddressInProgress = true
        this.$http.get('/api/id/generate').then((response) => {
          const alertsSettings = {}
          for (let i = 0; i < this.watchDogTypes.length; ++i) {
            const wdt = this.watchDogTypes[i]
            if (wdt === 'SALES_DROP' || wdt === 'PRICE' || wdt === 'INVENTORY' || wdt === 'FBM_INVENTORY') {
              alertsSettings[wdt] = { 'GREEN': false, 'RED': false, 'AMBER': false, orig: { 'GREEN': false, 'RED': false, 'AMBER': false } }
            } else if (wdt === 'BAD_REVIEW' || wdt === 'TOP_REVIEW') {
              alertsSettings[wdt] = { 'GREEN': false, 'RED': true, 'AMBER': true, orig: { 'GREEN': false, 'RED': false, 'AMBER': false } }
            } else {
              alertsSettings[wdt] = { 'GREEN': true, 'RED': true, 'AMBER': true, orig: { 'GREEN': false, 'RED': false, 'AMBER': false } }
            }
          }
          const primaryEa = this.emailAddresses.filter(ea => ea.isPrimary)[0]
          this.emailAddresses.splice(this.emailAddresses.length, 0, (function () {
            const obj = {
              emailAddressId: { value: response.body.id },
              email: body.email,
              originalEmail: '',
              emailValid: false,
              emailVerified: false,
              isNew: true,
              isDeleted: false,
              subscribedToDailyDigestEmail: true,
              subscribedToNewsletter: false,
              manageSubscriptionSettings: false,
              alertsSettings: alertsSettings,
              unsubscribedSellerAccounts: [],
              originalUnsubscribedSellerAccounts: [],
              allowedSellerAccounts: [],
              originalallowedSellerAccounts: [],
              timezoneOffset: primaryEa.timezoneOffset,
              timezoneAdjustToDST: primaryEa.timezoneAdjustToDST,
              digestEmailHour: primaryEa.digestEmailHour,
              isDirty: function () {
                return true
              },
            }
            obj.updateDigestTiming = function (timezoneOffset, timezoneAdjustToDST, digestEmailHour) {
              obj.timezoneOffset = timezoneOffset
              obj.timezoneAdjustToDST = timezoneAdjustToDST
              obj.digestEmailHour = digestEmailHour
            }
            return obj
          })())
          // this.addEmailAddressInProgress = false
          // add email starts
          const changedEmailAddresses = this.emailAddresses.filter(ea => !ea.isDeleted && ea.isDirty()).map(ea => {
            const alertTurnedOn = []
            const alertTurnedOff = []
            const sellerTurnedOn = ea.originalUnsubscribedSellerAccounts.filter((value) => ea.unsubscribedSellerAccounts.indexOf(value) === -1)
            const sellerTurnedOff = ea.unsubscribedSellerAccounts.filter((value) => ea.originalUnsubscribedSellerAccounts.indexOf(value) === -1)
            const sellerAccountAccessOff = ea.originalallowedSellerAccounts.filter((value) => ea.allowedSellerAccounts.indexOf(value) === -1)
            const sellerAccountAccessOn = ea.allowedSellerAccounts.filter((value) => ea.originalallowedSellerAccounts.indexOf(value) === -1)
            Object.entries(ea.alertsSettings).forEach(s => {
              const wdt = s[0]
              const settings = s[1]
              const wdtAlertTurnedOn = []
              const wdtAlertTurnedOff = []
              Object.keys(settings.orig).forEach(key => {
                if (settings[key] === true && settings.orig[key] === false) wdtAlertTurnedOn.splice(wdtAlertTurnedOn.length, 0, key)
                if (settings[key] === false && settings.orig[key] === true) wdtAlertTurnedOff.splice(wdtAlertTurnedOff.length, 0, key)
              })
              if (wdtAlertTurnedOn.length > 0) alertTurnedOn.splice(alertTurnedOn.length, 0, wdt + ':' + wdtAlertTurnedOn.join(','))
              if (wdtAlertTurnedOff.length > 0) alertTurnedOff.splice(alertTurnedOff.length, 0, wdt + ':' + wdtAlertTurnedOff.join(','))
            })
            return {
              emailAddressId: ea.emailAddressId,
              email: ea.email,
              isNew: ea.isNew,
              subscribedToDailyDigestEmail: ea.subscribedToDailyDigestEmail,
              subscribedToNewsletter: ea.subscribedToNewsletter,
              timezoneOffset: ea.timezoneOffset,
              timezoneAdjustToDST: ea.timezoneAdjustToDST,
              digestEmailHour: ea.digestEmailHour,
              alertTurnedOn: alertTurnedOn.join(';'),
              alertTurnedOff: alertTurnedOff.join(';'),
              sellersTurnedOn: sellerTurnedOn.join(';'),
              sellersTurnedOff: sellerTurnedOff.join(';'),
              sellersAccountAccessOn: sellerAccountAccessOn.join(';'),
              sellersAccountAccessOff: sellerAccountAccessOff.join(';')
            }
          })
          const data = {
            changedEmailAddresses: changedEmailAddresses,
            deletedEmailAddresses: this.emailAddresses.filter(ea => !ea.isNew && ea.isDeleted).map(ea => this.normalizeEmailAddressIdForApi(ea.emailAddressId)).filter(function (id) {
              return id != null && id !== ''
            }),
            sellerAccountNewNames: this.$refs.sellerAccounts ? this.$refs.sellerAccounts.filter(a => a.dirty).map(a => a.toJson()) : [],
            instantAlert: this.instantAlert,
            alertSubject: this.alertSubject,
            batchingIntervalMinutes: this.batchingIntervalHours * 60,
            firstName: this.firstName,
            lastName: this.lastName,
          }
          this.$http.put('/api/identity/settings', data).then((response) => {
            window.dirty = false
            this.message = 'Changes have been successfully changed'
            setTimeout(() => {
              this.message = ''
            }, 3000)
            this.$http.post('/api/auth/addUser', body).then((response) => {
              // this.emailAddresses[i].isUser = true
              // this.resetUser(i)
              this.addEmailAddressInProgress = false
              this.hideAddUserModal()
              this.successMessage = 'Submitted Changes have been Saved'
              setTimeout(() => {
                this.successMessage = ''
              }, 5000)
              // $('#successModal').modal('show')
              this.loadSettings()
              this.loadTenantUsers()
            }, (response) => {
              this.error = response.body.error + ': ' + response.body.message
              // this.resetUser(i)
              this.addEmailAddressInProgress = false
              this.hideAddUserModal()
            })
            // this.loadSettings()
            if (data.sellerAccountNewNames) this.$emit('sellerAccountsUpdated')
          }, (response) => {
            this.loadSettings()
            this.loadTenantUsers()
            this.addEmailAddressInProgress = false
            this.error = response.body.message
          })
          // add email ends
        }, (response) => {
          this.addEmailAddressInProgress = false
          this.error = response.body.message
        })
        // this.addEmailAddressInProgress = true
        // setTimeout(() => {
        //   // console.log('emails', JSON.stringify(this.emailAddresses))
        //   this.save()
        //   setTimeout(() => {
        //     this.$http.post('/api/auth/addUser', body).then((response) => {
        //       // this.emailAddresses[i].isUser = true
        //       // this.resetUser(i)
        //       this.addEmailAddressInProgress = false
        //       this.hideAddUserModal()
        //       this.message = 'Changes have been successfully changed'
        //       setTimeout(() => {
        //         this.message = ''
        //       }, 3000)
        //       this.loadSettings()
        //     }, (response) => {
        //       this.error = response.body.error + ': ' + response.body.message
        //       // this.resetUser(i)
        //       this.addEmailAddressInProgress = false
        //       this.hideAddUserModal()
        //     })
        //   }, 3000)
        // }, 3000)
        //
        // this.$http.post('/api/auth/addUser', body).then((response) => {
        //   console.log(response)
        //   this.emailAddresses[i].isUser = true
        //   this.resetUser(i)
        // }, (response) => {
        //   this.error = response.body.error + ': ' + response.body.message
        //   this.resetUser(i)
        // })
      }
    },
    toggleViewUser: function () {
      this.showAllUsers = !this.showAllUsers
      if (this.showAllUsers) {
        this.loadTenantUsers()
      }
    },
    resetUser: function (i) {
      this.user = {
        firstName: '',
        lastName: '',
        email: '',
      }
      this.emailAddresses[i].convertIntoUser = false
    },
    openConvertIntoUserModal: function (i) {
      if (!this.emailAddresses[i].convertIntoUser) {
        this.user.email = this.emailAddresses[i].email
      }
      this.emailAddresses[i].convertIntoUser = !this.emailAddresses[i].convertIntoUser
    },
    /** Scalar id for API payloads (`emailAddressId` may be `{ value: n }` from some responses). */
    normalizeEmailAddressIdForApi: function (id) {
      if (id == null || id === '') return null
      if (typeof id === 'object' && id.value !== undefined && id.value !== null) return id.value
      return id
    },
    resendVerification: function (emailAddress) {
      var addrId = emailAddress.emailAddressId
      if (addrId && typeof addrId === 'object' && addrId.value !== undefined) addrId = addrId.value
      this.$http.post('/api/identity/emailverification/' + addrId).then((response) => {
        this.message = 'Verification email has been sent'
        emailAddress.verificationEmailSent = true
        setTimeout(() => {
          this.message = ''
        }, 4000)
        setTimeout(() => {
          emailAddress.verificationEmailSent = false
        }, 30000)
      }, (response) => {
        this.error = response.body.error + ': ' + response.body.message
      })
    },
    checkSubscribe: function (sellerKey, index) {
      let keyIndex = this.emailAddresses[index].unsubscribedSellerAccounts.indexOf(sellerKey)
      if (keyIndex !== -1) {
        this.emailAddresses[index].unsubscribedSellerAccounts.splice(keyIndex, 1)
      } else {
        this.emailAddresses[index].unsubscribedSellerAccounts.push(sellerKey)
      }
      this.$forceUpdate()
    },
    checkSellerAccountsAccess: function (sellerKey, index) {
      let keyIndex = this.emailAddresses[index].allowedSellerAccounts.indexOf(sellerKey)
      if (keyIndex !== -1) {
        this.emailAddresses[index].allowedSellerAccounts.splice(keyIndex, 1)
      } else {
        this.emailAddresses[index].allowedSellerAccounts.push(sellerKey)
      }
      this.checkSubscribe(sellerKey, index)
      this.updateEmailDirty()
      this.$forceUpdate()
    },
    save: function (source) {
      const changedEmailAddresses = this.emailAddresses.filter(ea => !ea.isDeleted && ea.isDirty()).map(ea => {
        const alertTurnedOn = []
        const alertTurnedOff = []
        const sellerTurnedOn = ea.originalUnsubscribedSellerAccounts.filter((value) => ea.unsubscribedSellerAccounts.indexOf(value) === -1)
        const sellerTurnedOff = ea.unsubscribedSellerAccounts.filter((value) => ea.originalUnsubscribedSellerAccounts.indexOf(value) === -1)
        const sellerAccountAccessOff = ea.originalallowedSellerAccounts.filter((value) => ea.allowedSellerAccounts.indexOf(value) === -1)
        const sellerAccountAccessOn = ea.allowedSellerAccounts.filter((value) => ea.originalallowedSellerAccounts.indexOf(value) === -1)
        Object.entries(ea.alertsSettings).forEach(s => {
          const wdt = s[0]
          const settings = s[1]
          const wdtAlertTurnedOn = []
          const wdtAlertTurnedOff = []
          Object.keys(settings.orig).forEach(key => {
            if (settings[key] === true && settings.orig[key] === false) wdtAlertTurnedOn.splice(wdtAlertTurnedOn.length, 0, key)
            if (settings[key] === false && settings.orig[key] === true) wdtAlertTurnedOff.splice(wdtAlertTurnedOff.length, 0, key)
          })
          if (wdtAlertTurnedOn.length > 0) alertTurnedOn.splice(alertTurnedOn.length, 0, wdt + ':' + wdtAlertTurnedOn.join(','))
          if (wdtAlertTurnedOff.length > 0) alertTurnedOff.splice(alertTurnedOff.length, 0, wdt + ':' + wdtAlertTurnedOff.join(','))
        })
        return {
          emailAddressId: ea.emailAddressId,
          email: ea.email,
          isNew: ea.isNew,
          subscribedToDailyDigestEmail: ea.subscribedToDailyDigestEmail,
          subscribedToNewsletter: ea.subscribedToNewsletter,
          timezoneOffset: ea.timezoneOffset,
          timezoneAdjustToDST: ea.timezoneAdjustToDST,
          digestEmailHour: ea.digestEmailHour,
          alertTurnedOn: alertTurnedOn.join(';'),
          alertTurnedOff: alertTurnedOff.join(';'),
          sellersTurnedOn: sellerTurnedOn.join(';'),
          sellersTurnedOff: sellerTurnedOff.join(';'),
          sellersAccountAccessOn: sellerAccountAccessOn.join(';'),
          sellersAccountAccessOff: sellerAccountAccessOff.join(';')
        }
      })
      const data = {
        changedEmailAddresses: changedEmailAddresses,
        deletedEmailAddresses: this.emailAddresses.filter(ea => !ea.isNew && ea.isDeleted).map(ea => this.normalizeEmailAddressIdForApi(ea.emailAddressId)).filter(function (id) {
          return id != null && id !== ''
        }),
        sellerAccountNewNames: this.$refs.sellerAccounts ? this.$refs.sellerAccounts.filter(a => a.dirty).map(a => a.toJson()) : [],
        instantAlert: this.instantAlert,
        alertSubject: this.alertSubject,
        batchingIntervalMinutes: this.batchingIntervalHours * 60,
        firstName: this.firstName,
        lastName: this.lastName,
      }
      return this.$http.put('/api/identity/settings', data).then((response) => {
        window.dirty = false
        this.message = 'Changes have been successfully changed'
        setTimeout(() => {
          this.message = ''
        }, 3000)
        if (source === 'teams') {
          this.teamsMessage = 'Submitted Changes have been Saved'
          setTimeout(() => {
            this.teamsMessage = ''
          }, 3000)
        } else if (source === 'alerts') {
          this.alertMessage = 'Submitted Changes have been Saved'
          setTimeout(() => {
            this.alertMessage = ''
          }, 3000)
        }
        // $('#successModal').modal('show')
        this.loadSettings()
        this.loadTenantUsers()
        if (data.sellerAccountNewNames) this.$emit('sellerAccountsUpdated')
        return response
      }, (response) => {
        const body = response.body || {}
        this.error = body.message || response.statusText || 'Save failed'
        this.loadSettings()
        this.loadTenantUsers()
        return Promise.reject(response)
      })
    },
    loadSettings: function () {
      this.$http.get('/api/identity/settings').then((response) => {
        this.email = response.body.email
        this.isOwner = response.body.isOwner
        this.firstName = response.body.firstName
        this.firstNameOrig = response.body.firstName
        this.lastName = response.body.lastName
        this.lastNameOrig = response.body.lastName

        // Normalize per-address fields from API (shape differences / snake_case / alternate response paths)
        const body = response.body || {}
        let rawAddresses = []
        if (Array.isArray(body.emailAddresses)) {
          rawAddresses = body.emailAddresses
        } else if (body.settings && Array.isArray(body.settings.emailAddresses)) {
          rawAddresses = body.settings.emailAddresses
        }
        const toBool = function (v) {
          if (v === true || v === 1 || v === '1' || v === 'true') return true
          if (v === false || v === 0 || v === '0' || v === 'false') return false
          return undefined
        }
        rawAddresses.forEach(ea => {
          if (ea.allowedSellersAccount && !ea.allowedSellerAccounts) {
            ea.allowedSellerAccounts = ea.allowedSellersAccount
          }
          if (!ea.allowedSellerAccounts) {
            ea.allowedSellerAccounts = []
          }
          if (!ea.alertsSettings) {
            ea.alertsSettings = {}
          }
          if (ea.first_name && !ea.firstName) ea.firstName = ea.first_name
          if (ea.last_name && !ea.lastName) ea.lastName = ea.last_name
          if (ea.emailAddressId == null && ea.email_address_id != null) ea.emailAddressId = ea.email_address_id
          if (ea.emailAddressId == null && ea.id != null) ea.emailAddressId = ea.id

          if (ea.isPrimary === undefined) {
            if (ea.is_primary !== undefined) {
              ea.isPrimary = !!ea.is_primary
            } else if (toBool(ea.primary) !== undefined) {
              ea.isPrimary = toBool(ea.primary)
            }
          } else {
            const p = toBool(ea.isPrimary)
            if (p !== undefined) ea.isPrimary = p
          }

          let iu = toBool(ea.isUser)
          if (iu === undefined) iu = toBool(ea.is_user)
          if (iu === undefined) iu = toBool(ea.login_user)
          if (iu === undefined) iu = toBool(ea.loginUser)
          if (iu === undefined) iu = toBool(ea.can_login)
          if (iu === undefined) iu = toBool(ea.canLogin)
          if (iu !== undefined) {
            ea.isUser = iu
          } else {
            const notifyOnly = [ea.isNotificationOnly, ea.notification_only, ea.notificationOnly, ea.channel_only, ea.channelOnly].some(function (x) {
              return toBool(x) === true
            })
            ea.isUser = !notifyOnly
          }
        })

        this.emailAddresses = rawAddresses.sort((a, b) => {
          const c = (a.isPrimary ? -1 : 1) - (b.isPrimary ? -1 : 1)
          if (c !== 0) return c
          return a.email.localeCompare(b.email)
        }).map(ea => $.extend(ea, {
          originalEmail: ea.email,
          originalSubscribedToDailyDigestEmail: ea.subscribedToDailyDigestEmail,
          originalSubscribedToNewsletter: ea.subscribedToNewsletter,
          originalTimezoneOffset: ea.timezoneOffset,
          originalTimezoneAdjustToDST: ea.timezoneAdjustToDST,
          originalDigestEmailHour: ea.digestEmailHour,
          manageSubscriptionSettings: false,
          convertIntoUser: false,
          manageSellerPermissions: false,
          alertChanged: function () {
            let result = false
            Object.values(ea.alertsSettings).forEach(wd => {
              Object.keys(wd.orig).forEach(status => {
                result = result || wd.orig[status] !== wd[status]
              })
            })
            return result
          },
          subscribedChanged: function () {
            let original = new Set(ea.originalUnsubscribedSellerAccounts)
            let current = new Set(ea.unsubscribedSellerAccounts)
            if (original.size !== current.size) {
              return false
            }

            return Array.from(original).every(element => {
              return current.has(element)
            })
          },
          sellerAccessChanged: function () {
            let original = new Set(ea.originalallowedSellerAccounts)
            let current = new Set(ea.allowedSellerAccounts)
            if (original.size !== current.size) {
              return false
            }

            return Array.from(original).every(element => {
              return current.has(element)
            })
          },
          isDirty: function () {
            return this.subscribedToDailyDigestEmail !== this.originalSubscribedToDailyDigestEmail || this.subscribedToNewsletter !== this.originalSubscribedToNewsletter || this.isNew || this.isDeleted ||
              this.email !== this.originalEmail || this.timezoneOffset !== this.originalTimezoneOffset || this.timezoneAdjustToDST !== this.originalTimezoneAdjustToDST ||
              this.digestEmailHour !== this.originalDigestEmailHour || this.alertChanged() || !this.subscribedChanged() || !this.sellerAccessChanged()
          },
          updateDigestTiming: function (timezoneOffset, timezoneAdjustToDST, digestEmailHour) {
            ea.timezoneOffset = timezoneOffset
            ea.timezoneAdjustToDST = timezoneAdjustToDST
            ea.digestEmailHour = digestEmailHour
          },
          verificationEmailSent: false,
        }))
        this.emailAddresses.forEach(ea => {
          if (ea.unsubscribedSellerAccounts === undefined) {
            ea.unsubscribedSellerAccounts = []
          }
          ea.originalUnsubscribedSellerAccounts = ea.unsubscribedSellerAccounts.map((x) => x)
          Object.values(ea.alertsSettings).forEach(wd => {
            Object.keys(wd).forEach(status => {
              wd.orig = wd.orig || {}
              wd.orig[status] = wd[status]
            })
          })
          if (ea.allowedSellerAccounts === undefined) {
            ea.allowedSellerAccounts = []
          }
          ea.originalallowedSellerAccounts = ea.allowedSellerAccounts.map((x) => x)
        })
        this.timezone = response.body.timezoneOffset
        this.initialTimezone = response.body.timezoneOffset
        this.initialTimezoneAdjustToDST = response.body.timezoneAdjustToDST
        this.timezoneAdjustToDST = response.body.timezoneAdjustToDST
        if (this.timezoneElement != null) {
          $(this.timezoneElement).dropdown('set exactly', this.timezone)
        }
        this.dailyDigestTime = response.body.digestEmailHour
        this.initialDailyDigestTime = response.body.digestEmailHour
        if (this.dailyDigestTimeElement != null) {
          $(this.dailyDigestTimeElement).dropdown('set exactly', this.dailyDigestTime)
        }
        this.initialInstantAlert = response.body.instantAlert
        this.instantAlert = response.body.instantAlert
        this.alertSubject = response.body.alertSubject
        this.initialAlertSubject = response.body.alertSubject
        this.batchingIntervalHours = response.body.batchingIntervalMinutes / 60
        this.initialBatchingIntervalHours = this.batchingIntervalHours
        let wdts = Object.keys(response.body.watchDogTypesToDisplayName || {})
        for (let i = 0; i < wdts.length; ++i) {
          if (!this.watchDogTypesToDisplayName[wdts[i]]) {
            this.watchDogTypesToDisplayName[wdts[i]] = response.body.watchDogTypesToDisplayName[wdts[i]]
          }
        }
        wdts = Object.keys(this.watchDogTypesToDisplayName)
        for (let i = 0; i < wdts.length; ++i) {
          if (this.watchDogTypes.indexOf(wdts[i]) < 0) {
            this.watchDogTypes.splice(this.watchDogTypes.length, 0, wdts[i])
          }
        }
        const sellerAccountsList = Array.isArray(response.body.sellerAccounts) ? response.body.sellerAccounts : []
        this.anyAccountMayNeedReAuthorization = sellerAccountsList.filter(sa => sa.mayNeedReauthorization).length > 0
        this.sellers = sellerAccountsList
        const primaryEa = this.emailAddresses.filter(ea => ea.isPrimary)[0]
        const allowed = primaryEa && Array.isArray(primaryEa.allowedSellerAccounts) ? primaryEa.allowedSellerAccounts : []
        var self = this
        this.filteredSellers = this.sellers.filter(function (s) {
          return self.isOwner || self.sellerIdInList(allowed, s.sellerId && s.sellerId.value !== undefined ? s.sellerId.value : s.sellerId)
        })
        this.showAdvertisementApiSettings = response.body.showAdvertisementApiSettings
        this.alertUser = null
        this.updateEmailDirty()
        this.onSellerAccountChanged()
        var self = this
        this.$nextTick(function () {
          self.refreshSemanticDropdowns()
          if (self.isOwner && self.selectedTeamStorefronts && self.selectedTeamStorefronts.length) {
            self.syncAssignedUserListFromTeamStorefronts()
          }
        })
      }, (response) => {
        const body = response.body || {}
        this.error = body.message || response.statusText || 'Failed to load settings'
      })
    },
    refreshSemanticDropdowns: function () {
      var $ = window.$
      if (!$ || !this.$el) return
      var refs = [this.$refs.assignedUser, this.$refs.alertUser, this.$refs.dropdown, this.$refs.storefrontTeamSelect]
      for (var i = 0; i < refs.length; i++) {
        var el = refs[i]
        if (!el) continue
        var $el = $(el)
        if (!$el.length) continue
        try {
          if (typeof $el.dropdown === 'function') {
            $el.dropdown('refresh')
          }
        } catch (e) {}
      }
    },
    timezoneOffsetMinutes: function () {
      return 0 - new Date().getTimezoneOffset()
    },
    loadBilling: function () {
      this.$http.get('/api/billing/payment-status', {params: {timezoneOffsetMinutes: this.timezoneOffsetMinutes()}}).then(response => {
        this.paymentStatusMessage = response.body.message
        this.subscriptionCanceled = response.body.canceled
        this.packageDetails = response.body.packageDetails
        this.addonCount = response.body.addonCount
        this.hasPaymentDetails = response.body.hasPaymentDetails
        this.paymentMethod = response.body.paymentMethod
      }, response => {
        this.error = response.body.message
      })
    },
    showAddSellerAccountModal: function () {
      $('#addSellerAccountModal').modal('show')
    },
    onSellerAccountAdded: function () {
      $('#addSellerAccountModal').modal('hide')
      this.$emit('sellerAccountsUpdated')
      this.$http.get('/api/identity/settings').then((response) => {
        const sellerIds = this.sellers.map(s => s.sellerId.value)
        const newSellers = response.body.sellerAccounts
        for (let i = 0; i < newSellers.length; ++i) {
          if (sellerIds.indexOf(newSellers[i].sellerId.value) < 0) {
            this.sellers.splice(this.sellers.length, 0, newSellers[i])
          }
        }
      }, (response) => {
        this.error = response.body.message
      })
    },
    showInvoiceModal: function () {
      this.$http.get('/api/billing/invoices', {params: {timezoneOffsetMinutes: this.timezoneOffsetMinutes()}}).then(response => {
        this.invoices = response.body.invoices
        this.billingName = response.body.billingName
        this.editBillingNameState = false
        $('#invoicesModal').modal({centered: false}).modal('show')
      }, response => {
        this.error = response.body.message
      })
    },
    saveBillingName: function () {
      this.editBillingNameState = 'inprogress'
      this.$http.put('/api/billing/billing-details', {billingName: this.billingName}).then(response => {
        this.$http.get('/api/billing/invoices', {params: {timezoneOffsetMinutes: this.timezoneOffsetMinutes()}}).then(response => {
          this.invoices = response.body.invoices
          this.billingName = response.body.billingName
          this.editBillingNameState = false
        }, response => {
          this.error = response.body.message
        })
      }, response => {
        this.editBillingNameState = false
        this.error = response.body.message
      })
    },
    onSellerAccountChanged: function () {
      this.sellersDirty = this.$refs.sellerAccounts && (this.$refs.sellerAccounts.filter(s => s.dirty).length > 0)
    },
    addEmailAddress: function () {
      this.addEmailAddressInProgress = true
      this.$http.get('/api/id/generate').then((response) => {
        const alertsSettings = {}
        for (let i = 0; i < this.watchDogTypes.length; ++i) {
          const wdt = this.watchDogTypes[i]
          if (wdt === 'SALES_DROP' || wdt === 'PRICE' || wdt === 'INVENTORY' || wdt === 'FBM_INVENTORY') {
            alertsSettings[wdt] = {'GREEN': false, 'RED': false, 'AMBER': false, orig: {'GREEN': false, 'RED': false, 'AMBER': false}}
          } else if (wdt === 'BAD_REVIEW' || wdt === 'TOP_REVIEW') {
            alertsSettings[wdt] = {'GREEN': false, 'RED': true, 'AMBER': true, orig: {'GREEN': false, 'RED': false, 'AMBER': false}}
          } else {
            alertsSettings[wdt] = {'GREEN': true, 'RED': true, 'AMBER': true, orig: {'GREEN': false, 'RED': false, 'AMBER': false}}
          }
        }
        const primaryEa = this.emailAddresses.filter(ea => ea.isPrimary)[0]
        this.emailAddresses.splice(this.emailAddresses.length, 0, (function () {
          const obj = {
            emailAddressId: {value: response.body.id},
            email: '',
            originalEmail: '',
            emailValid: false,
            emailVerified: false,
            isNew: true,
            isDeleted: false,
            subscribedToDailyDigestEmail: true,
            subscribedToNewsletter: false,
            manageSubscriptionSettings: false,
            alertsSettings: alertsSettings,
            unsubscribedSellerAccounts: [],
            originalUnsubscribedSellerAccounts: [],
            allowedSellerAccounts: [],
            originalallowedSellerAccounts: [],
            timezoneOffset: primaryEa.timezoneOffset,
            timezoneAdjustToDST: primaryEa.timezoneAdjustToDST,
            digestEmailHour: primaryEa.digestEmailHour,
            isDirty: function () {
              return true
            },
          }
          obj.updateDigestTiming = function (timezoneOffset, timezoneAdjustToDST, digestEmailHour) {
            obj.timezoneOffset = timezoneOffset
            obj.timezoneAdjustToDST = timezoneAdjustToDST
            obj.digestEmailHour = digestEmailHour
          }
          return obj
        })())
        this.addEmailAddressInProgress = false
      }, (response) => {
        this.addEmailAddressInProgress = false
        this.error = response.body.message
      })
      return false
    },
    updateEmailDirty: function () {
      this.emailDirty = this.emailAddresses.filter(ea => ea.isDirty()).length > 0
    },
    deleteEmailAddress: function (i) {
      if (this.emailAddresses[i].isNew) {
        this.emailAddresses.splice(i, 1)
      } else {
        this.emailAddresses[i].isDeleted = true
      }
      this.updateEmailDirty()
    },
    isValidEmail: function (candidate) {
      const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
      return re.test(candidate.email) && (candidate.isPrimary || this.emailAddresses.filter(ea => ea !== candidate && ea.email === candidate.email).length === 0)
    },
    sellerAccountDeleted: function (sellerId) {
      this.message = 'Account deletion in progress'
      setTimeout(() => {
        this.message = ''
      }, 3000)
      this.$emit('sellerAccountsUpdated')
      for (let i = 0; i < this.sellers.length; ++i) {
        if (this.sellers[i].sellerId.value === sellerId) {
          this.sellers.splice(i, 1)
          break
        }
      }
    },
    isEmptyObject: function (o) {
      return o === null || Object.keys(o).length === 0
    },
    openStripeWidget: function () {
      this.stripeButtonClicked = true
      // Close the payment methods popup
      $('#paymentMethods').popup('hide')
      this.initPaymentElement()
    },
    initPaymentElement: async function () {
      const self = this
      if (this.stripeInstance && this.paymentElement) {
        // Already initialized, just show modal
        $('#paymentElementModal').modal('show')
        return
      }

      try {
        // Load Stripe.js
        const { loadStripe } = await import('@stripe/stripe-js')
        const publishableKey = stripePublishableKey()

        this.stripeInstance = await loadStripe(publishableKey)

        // Create SetupIntent on backend
        this.updatePaymentInProgress = true
        const setupIntentResponse = await this.$http.post('/api/billing/setup-intent/create')
        const clientSecret = setupIntentResponse.body.clientSecret

        // Create Payment Element
        const elements = this.stripeInstance.elements({
          clientSecret: clientSecret,
          appearance: {
            theme: 'stripe'
          }
        })

        // Store the elements group for confirmSetup()
        this.elementsGroup = elements

        this.paymentElement = elements.create('payment')
        this.paymentElement.mount('#payment-element')

        // Handle form submission
        this.setupIntentClientSecret = clientSecret
        this.updatePaymentInProgress = false
        $('#paymentElementModal').modal('show')
      } catch (error) {
        console.error('Error initializing Payment Element:', error)
        this.error = 'Failed to load payment form. Please try again.'
        this.updatePaymentInProgress = false
        this.stripeButtonClicked = false
      }
    },
    confirmPaymentMethod: async function () {
      const self = this
      if (!this.stripeInstance || !this.setupIntentClientSecret) {
        this.error = 'Payment form not initialized'
        return
      }

      try {
        this.updatePaymentInProgress = true

        const { error: submitError } = await this.stripeInstance.confirmSetup({
          elements: this.elementsGroup,
          confirmParams: {
            return_url: window.location.origin + '/settings?payment_method_set=success'
          },
          redirect: 'if_required'
        })

        if (submitError) {
          this.error = submitError.message
          this.updatePaymentInProgress = false
          return
        }

        // Payment method confirmed successfully
        this.updatePaymentInProgress = false
        this.message = 'Payment method has been updated'
        this.paymentDetailsSaved = true
        $('#paymentElementModal').modal('hide')
        this.loadBilling()

        setTimeout(() => {
          this.message = ''
        }, 4000)

        // Clean up
        if (this.paymentElement) {
          this.paymentElement.unmount()
          this.paymentElement = null
        }
        this.elementsGroup = null
        this.setupIntentClientSecret = null
        this.stripeButtonClicked = false
      } catch (error) {
        console.error('Error confirming payment method:', error)
        this.error = error.message || 'Failed to update payment method'
        this.updatePaymentInProgress = false
      }
    },
    handlePaymentMethodReturn: function () {
      const urlParams = new URLSearchParams(window.location.search)
      if (urlParams.get('payment_method_set') === 'success') {
        this.message = 'Payment method has been updated'
        this.paymentDetailsSaved = true
        this.loadBilling()
        setTimeout(() => {
          this.message = ''
        }, 4000)
        // Clean up URL
        window.history.replaceState({}, document.title, '/settings')
      }
    },
    cancelSubscriptionConfirm: function () {
      this.cancelInProgress = true
      // if (window.location.hostname.includes('sentrykit')) {
      //   window.hj('event', 'cancel_subscription_ev')
      // }
      this.$http.delete('/api/billing/subscription/cancel').then(res => {
        this.loadBilling()
        $('#cancelSubscriptionModal').modal('hide')
        this.cancelInProgress = false
        this.error = res.body.message
        window.alert('Your subscription has now been cancelled. \nYou may still use SentryKit until the end of this billing period.')
        this.$router.push('/cancelsubscription')
      }, res => {
        this.error = res.body.message
        $('#cancelSubscriptionModal').modal('hide')
        this.cancelInProgress = false
      })
      return false
    },
    newPricingOrDiscount: function () {
      console.info('SettingsPage:')
      console.info(this.$root.hasDailyPricing)
      if (!this.$root.hasDailyPricing) {
        console.info('Offering new plan')
        $('#cancelSubscriptionModal').modal('hide')
        $('#cancelSubscriptionNewPricingModal').modal('show')
      } else {
        console.info('Offering discount')
        $('#cancelSubscriptionModal').modal('show')
        $('#cancelSubscriptionNewPricingModal').modal('hide')
      }
    },
    redeemNewPricing: function () {
      this.$http.put('/api/billing/subscription/daily').then(res => {
        $('#cancelSubscriptionNewPricingModal').modal('hide')
        this.cancelInProgress = false
        this.redeemedNewPricing = true
        this.$router.push('/newpricingredeemed')
      }, res => {
        this.error = res.body.message
        $('#cancelSubscriptionNewPricingModal').modal('hide')
        this.cancelInProgress = false
      })
    },
    applyCouponConfirm: function () {
      this.cancelInProgress = true
      this.$http.put('/api/billing/subscription/apply/coupon').then(res => {
        this.loadBilling()
        $('#cancelSubscriptionModal').modal('hide')
        this.cancelInProgress = false
        if (res.body.message) {
          this.error = res.body.message
        } else {
          // window.alert('Thank you for continuing your subscription.\nWe appreciate being able to service your account.')
          this.$router.push('/subscription')
        }
      }, res => {
        this.error = res.body.message
        $('#cancelSubscriptionModal').modal('hide')
        this.cancelInProgress = false
      })
    },
    openCancelConfirm: function () {
      $('#cancelSubscription').modal({
        onApprove: (e) => {
          // $('#cancelSubscriptionModal').modal('show')
          // if (window.location.hostname.includes('sentrykit')) {
          //   window.hj('event', 'cancel_subscription_ev')
          // }
          // this.cancelInProgress = true
          // $('#cancelSubscription').modal('hide')
          // this.$http.delete('/api/billing/subscription/cancel').then(res => {
          //   this.loadBilling()
          //   $('#cancelSubscription').modal('hide')
          //   this.cancelInProgress = false
          //   window.alert('Your subscription has now been cancelled. \nYou may still use SentryKit until the end of this billing period.')
          // }, res => {
          //   this.error = res.body.message
          //   $('#cancelSubscription').modal('hide')
          //   this.cancelInProgress = false
          // })
          return false
        }
      }).modal('show')
    },
    openResumeConfirm: function () {
      $('#resumeSubscription').modal({
        onApprove: (e) => {
          this.resumeInProgress = true
          this.$http.put('/api/billing/subscription/resume').then(res => {
            this.loadBilling()
            $('#resumeSubscription').modal('hide')
            this.resumeInProgress = false
          }, res => {
            this.error = res.body.message
            $('#resumeSubscription').modal('hide')
            this.resumeInProgress = false
          })
          return false
        }
      }).modal('show')
    },
    disabled: function (wdt, status) {
      if (status === 'GREEN') return ['SALES_DROP', 'KEYWORD', 'LOST_BUYBOX', 'BEST_SELLER_BADGE', 'STAR_RATING_RECENT_CHANGE', 'PRICE', 'BAD_REVIEW', 'NO_ADD_TO_CART', 'SEARCH_BAN', 'INVENTORY', 'FBM_INVENTORY'].indexOf(wdt) < 0
      if (status === 'AMBER') return ['SALES_DROP', 'BAD_REVIEW', 'TOP_REVIEW', 'STAR_RATING_RECENT_CHANGE', 'PRICE', 'INVENTORY'].indexOf(wdt) < 0
      return false
    },
    autoSelectProducts: function (addonCount) {
      const productCount = this.packageDetails.baseSubscriptionProducts + addonCount * this.packageDetails.addonSubscriptionProducts
      this.autoSelectingAddon = addonCount
      this.$http.put('/api/product/auto-select', {productCount: productCount}).then(res => {
        $('#cancelSubscription').modal('hide')
        this.$router.push('/productsettings')
      }, res => {
        $('#cancelSubscription').modal('hide')
        this.$router.push('/productsettings')
      })
    },
    loadAuthorizations: function () {
      this.$http.get('/api/identity/authorizations').then(response => {
        this.authorizations = response.body.map(a => $.extend(a, {clicked: false}))
        this.googleSheetsList = this.authorizations.filter(a => a.name === 'Google Sheets')
        this.zapierList = this.authorizations.filter(a => a.name === 'Zapier')
        this.googleSheetAuth = this.googleSheetsList > 0 ? this.googleSheetsList[0] : null
        this.zapierAuth = this.zapierList > 0 ? this.zapierList[0] : null
      })
    },
    deleteAuthorization: function (a) {
      if (a.clicked) {
        this.$http.delete('/api/identity/authorization/' + a.id).then(response => {
          this.loadAuthorizations()
        })
      } else {
        a.clicked = true
      }
    },
    googleSheetsAuthorizationUrl: function () {
      this.$http.get('/api/googlesheets/authorizationurl').then(response => {
        window.open(response.body, '_blank')
      })
    },
    googleSheetsUrl: function () {
      window.open('https://docs.google.com/spreadsheets/d/' + this.gsheetsConnection.spreadsheetId, '_blank')
    },
    createAchSource: function () {
      this.updatePaymentInProgress = true
      this.$http.put('/api/billing/ach-source').then(response => {
        this.updatePaymentInProgress = false
        this.message = 'Payment method has been updated'
        this.paymentDetailsSaved = true
        this.loadBilling()
        setTimeout(() => {
          this.message = ''
        }, 4000)
      }, response => {
        this.updatePaymentInProgress = false
        this.error = response.body.message
        this.loadBilling()
      })
    },
    viewAchDetails: function () {
      $('#paymentMethods').popup('hide')
      $('#paymentMethodModal').modal('show')
      if (this.paymentMethod && this.paymentMethod.method === 'ach') {
        let progressEl = $('#achProgressBalance')
        if (progressEl) progressEl.progress()
      }
    },
    showAddUserModal: function () {
      $('#addUserModal').modal({centered: false}).modal('show')
    },
    hideAddUserModal: function () {
      $('#addUserModal').modal({centered: false}).modal('hide')
    },
    showDeactivateUserModal: function () {
      var self = this
      this.loadTenantUsers()
      $('#deactivateUserModal').modal({
        centered: false,
        onVisible: function () {
          self.$nextTick(function () {
            self.refreshSemanticDropdowns()
            try {
              if (self.$refs.dropdown && window.$(self.$refs.dropdown).length) {
                window.$(self.$refs.dropdown).dropdown('clear')
              }
            } catch (e) {}
          })
        },
      }).modal('show')
    },
    hideDeactivateUserModal: function () {
      $('#deactivateUserModal').modal({centered: false}).modal('hide')
    },
  },
  computed: {
    timezoneDirty: function () {
      return this.timezone !== this.initialTimezone || this.timezoneAdjustToDST !== this.initialTimezoneAdjustToDST
    },
    nameDirty: function () {
      return this.firstName !== this.firstNameOrig || this.lastName !== this.lastNameOrig
    },
    dailyDigestTimeDirty: function () {
      return this.dailyDigestTime !== this.initialDailyDigestTime
    },
    instantAlertDirty: function () {
      return this.initialInstantAlert !== this.instantAlert
    },
    alertSubjectDirty: function () {
      return this.initialAlertSubject !== this.alertSubject
    },
    batchingIntervalHoursDirty: function () {
      return this.initialBatchingIntervalHours !== this.batchingIntervalHours
    },
    dirty: function () {
      return (this.emailDirty || this.sellersDirty || this.timezoneDirty || this.nameDirty || this.dailyDigestTimeDirty || this.instantAlertDirty || (this.instantAlert && this.alertSubjectDirty) || (!this.instantAlert && this.batchingIntervalHoursDirty)) && this.emailsValid
    },
    packageCost: function () {
      return this.packageDetails ? this.packageDetails.baseSubscriptionFeeCents + this.packageDetails.addonSubscriptionFeeCents * this.addonCount : null
    },
    hasEnoughACHFunds: function () {
      return this.paymentMethod.details ? this.paymentMethod.details.balance >= this.packageCost : null
    },
    /** Rows for Manage Your Users expanded table: `/api/identity/users` + matching `emailAddresses` row for verification. */
    manageUsersTableRows: function () {
      var self = this
      var users = Array.isArray(this.tenantUsers) ? this.tenantUsers : []
      return users.map(function (u) {
        var ea = null
        for (var i = 0; i < self.emailAddresses.length; i++) {
          var row = self.emailAddresses[i]
          if (!row.isDeleted && row.email === u.email) {
            ea = row
            break
          }
        }
        return { user: u, emailAddress: ea }
      })
    },
    /** Primary account email from settings (exclude from team / alert pickers like legacy non-primary filter). */
    primarySettingsAccountEmail: function () {
      var p = this.emailAddresses.filter(function (ea) {
        return ea.isPrimary
      })[0]
      return p && p.email ? p.email : ''
    },
    /** `/api/identity/users` rows for storefront-team and alert dropdowns (values still match `emailAddresses` by email). */
    tenantUsersForTeamAndAlertsDropdown: function () {
      var primary = this.primarySettingsAccountEmail
      var list = Array.isArray(this.tenantUsers) ? this.tenantUsers : []
      if (!primary) {
        return list.slice()
      }
      return list.filter(function (u) {
        return u.email && u.email !== primary
      })
    },
    /** Deactivate modal: API users except account owner (cannot deactivate owner). */
    tenantUsersForDeactivateModal: function () {
      var primary = this.primarySettingsAccountEmail
      var list = Array.isArray(this.tenantUsers) ? this.tenantUsers : []
      return list.filter(function (u) {
        if (!u.email) return false
        if (u.isOwner) return false
        if (primary && u.email === primary) return false
        return true
      })
    }
  },
  watch: {
    emailAddresses: {
      handler: function (value) {
        let emailsValid = true
        this.updateEmailDirty()
        for (let i = 0; i < value.length; ++i) {
          const ea = value[i]
          ea.email = ea.email.replace(/[ |\t]/g, '')
          ea.emailValid = this.isValidEmail(ea)
          ea.validationEmailSent = false
          emailsValid = emailsValid && ea.emailValid
        }
        this.emailsValid = emailsValid
      },
      deep: true,
    },
    subscribedToDailyDigestEmail: function () {
      this.updateEmailDirty()
    },
    subscribedToNewsletter: function () {
      this.updateEmailDirty()
    },
    dirty: function () {
      window.dirty = this.dirty
    },
    tenantUsers: function () {
      var self = this
      this.$nextTick(function () {
        self.refreshSemanticDropdowns()
      })
    },
  },
  created: function () {
    this.loadSettings()
    this.loadTenantUsers()
    if (this.$root.paymentStatus !== 0) this.loadBilling()
    this.loadAuthorizations()
    this.$http.get('/api/googlesheets/connection-status').then(response => {
      this.gsheetsConnection = response.body
    })
    this.fetchSuppressedWatchdogs()
  },
  mounted: function () {
    this.handlePaymentMethodReturn()
    this.addNotificationEmailAddressesModalElement = $('#addNotificationEmailAddressesModal')
    this.addNotificationEmailAddressesModalElement.modal({onApprove: this.addEmailAddress})

    let paymentMethodElement = $('#paymentMethods')
    paymentMethodElement.popup({ on: 'click' })
    $(this.$refs.dropdown).dropdown({
      onChange: (value, text, $selectedItem) => {
        var vals = value ? String(value).split(',').filter(function (v) { return v !== '' }) : []
        if (vals.indexOf('-1') !== -1) {
          this.selectedOptions = this.tenantUsersForDeactivateModal.map(function (u) {
            return u.email
          })
        } else {
          this.selectedOptions = vals
        }
      },
    })
    $(this.$refs.assignedUser).dropdown({
      onChange: (value, text, $selectedItem) => {
        var vals = value ? String(value).split(',').filter(function (v) { return v !== '' }) : []
        this.selectedAssignedUser = vals
        if (vals.indexOf('-1') !== -1) {
          this.assignedUserList = this.emailAddresses
        } else {
          this.assignedUserList = this.emailAddresses.filter(function (ea) {
            return vals.indexOf(ea.email) !== -1
          })
        }
      },
    })
    if (this.$refs.storefrontTeamSelect) {
      var self = this
      $(this.$refs.storefrontTeamSelect).dropdown({
        fullTextSearch: 'exact',
        onChange: function (value) {
          var vals = value ? String(value).split(',').filter(function (v) { return v !== '' }) : []
          self.selectedTeamStorefronts = vals
          self.syncAssignedUserListFromTeamStorefronts()
        }
      })
    }
    if (this.$refs.alertUser) {
      $(this.$refs.alertUser).dropdown({
        onChange: (value, text, $selectedItem) => {
          this.alertUser = value || null
          this.onAlertUserChange()
        },
      })
    }
  },
  beforeRouteLeave (to, from, next) {
    if (!window.dirty) {
      next()
    } else if (window.confirm('Please confirm that you want to close your Account Settings.\nYou have some unsaved changes.')) {
      window.dirty = false
      next()
    }
  },
  destroyed: function () {
    $('#cancelSubscription').remove()
    $('#invoicesModal').remove()
  }
}
</script>

<style>
#prodSettBG .changed-color {color:#fa5;}
.ui.table.emailSettingsTable tr td { border-top: 0px !important; }

.alertSettingsAni {
  zzz-index: 5;
  border: 4px solid purple; border-radius: 70px; height: 140px; width: 140px;
  position: absolute; zzleft:90px; top:-20%;
  animation: pulsate 1.5s ease-out; opacity: 0.0
}
.left-aligned-container {
  float: left;
}
.borderButton {
  border: 3px solid peru !important;
}
.marginBotton-1 {
  margin-bottom: -1rem;
}

.marginBotton-2 {
  margin-bottom: 2rem;
}

.bordered-button-green {
  border: 3px solid green !important;
}
.sub-heading{
  font-size: 15px;
}

.margin-top-2 {
  margin-top: 2rem;
}
.greyed-out {
    color: grey;
    background-color: rgba(200, 200, 200, 0.4); /* Light grey overlay */
    position: relative;
  }


  .greyed-out:hover::after {
    content: 'Upgrade your plan to unlock this alert and access all 25+ critical notifications';
    position: absolute;
    top: -30px;
    left: 10px;
    background-color: #333;
    color: #fff;
    padding: 6px 10px;
    border-radius: 5px;
    font-size: 12px;
    white-space: nowrap;
    z-index: 1000;
  }
</style>



// WEBPACK FOOTER //
// SettingsPage.vue?60401990